<template>
  <page-header-wrapper>
    <div class="dashboard-page">
      <div class="filter-bar">
        <span class="filter-label">当前项目</span>
        <a-select
          v-model:value="selectedProject"
          class="project-select"
          size="large"
          show-search
          allow-clear
          :filter-option="filterProjectOption"
          placeholder="请选择项目"
          @change="handleProjectChange"
        >
          <a-select-option
            v-for="project in projectList"
            :key="project.id"
            :value="project.id"
          >
            {{ project.chineseName || project.projectCode }}
          </a-select-option>
        </a-select>
        <span class="filter-label time-label">时间</span>
        <a-range-picker
          v-model:value="dateRange"
          format="YYYY-MM-DD"
          valueFormat="YYYY-MM-DD"
          :placeholder="['开始时间', '结束时间']"
          :disabled-date="disableFutureDate"
          inputReadOnly
          allow-clear
          class="time-filter-picker"
          @change="handleDateChange"
        />
      </div>

      <div class="content-card">
        <!-- 顶部统计行 -->
        <div class="top-summary-row">
          <!-- 任务数据卡片 -->
          <div class="task-data-section top-card">
            <div class="task-data-header">
              <span class="section-title">任务数据</span>
              <a class="summary-link">查看详情</a>
            </div>
            <template v-if="summaryCards && summaryCards.length > 0">
              <div class="task-data-grid">
                <div
                  class="task-data-card"
                  v-for="card in summaryCards"
                  :key="card.title"
                  :class="getCardClass(card)"
                  @click="openTaskDetail(card)"
                >
                  <div class="task-data-icon">
                    <img :src="getTaskCardImage(card)" :alt="card.title" />
                  </div>
                  <div class="task-data-content">
                    <p class="task-data-label">{{ card.title }}</p>
                    <p class="task-data-value">
                      {{ card.isPercent ? card.value + '%' : card.value }}
                    </p>
                  </div>
                </div>
              </div>
            </template>
            <a-empty
              v-else
              description="暂无数据"
              class="panel-empty"
              style="padding: 40px 0"
            />
          </div>

          <!-- 手环数据 -->
          <div class="stats-card top-card">
            <div class="stats-card__header">
              <span class="section-title">{{ wristbandStats.title }}</span>
              <a class="summary-link">查看详情</a>
            </div>
            <div class="stats-card__body">
              <div class="stats-info stats-info--wristband">
                  <div
                  class="stats-row stats-row--clickable"
                    v-for="item in wristbandStats.list"
                    :key="item.label"
                  @click="openWristbandDetail"
                  >
                    <p class="stats-row-value">{{ item.value }}</p>
                    <p class="stats-row-label">{{ item.label }}</p>
                  </div>
                </div>
              <!-- <div class="stats-chart">
                <div ref="wristbandChart" class="stats-chart-echart"></div>
              </div> -->
            </div>
          </div>

          <!-- 出勤数据 -->
          <div class="stats-card top-card">
            <div class="stats-card__header">
              <span class="section-title">{{ attendanceStats.title }}</span>
              <a class="summary-link">查看详情</a>
            </div>
            <div class="stats-card__body">
              <div class="stats-info stats-info--vertical">
                  <div
                  class="stats-row stats-row--clickable"
                    v-for="item in attendanceStats.list"
                    :key="item.label"
                  @click="openAttendanceDetail"
                  >
                    <p class="stats-row-value">{{ item.value }}</p>
                    <p class="stats-row-label">{{ item.label }}</p>
                  </div>
                </div>
                <div class="stats-chart">
                  <div ref="attendanceChart" class="stats-chart-echart"></div>
                </div>
            </div>
          </div>

          <!-- 投诉数据卡片：isToday 为 true 显示全部，为 false 只显示 投诉数、处理中、已完成 -->
          <div class="complaint-data-section top-card">
            <div class="complaint-data-header">
              <span class="complaint-data-title">投诉数据</span>
              <a class="summary-link">查看详情</a>
            </div>
            <template v-if="complaintIsToday">
              <div class="complaint-data-summary">
                <span class="complaint-data-summary-item">
                  今日投诉 <em class="complaint-data-summary-num">{{ complaintData.today.total }}</em>
                </span>
                <span class="complaint-data-summary-item">
                  本月投诉 <em class="complaint-data-summary-num">{{ complaintData.month.total }}</em>
                </span>
                </div>
              <div class="complaint-data-grid">
                <div
                  class="complaint-data-subcard complaint-data-subcard--clickable"
                  @click="openComplaintDetail('today')"
                >
                  <span class="complaint-data-number">{{ complaintData.today.processing }}</span>
                  <span class="complaint-data-label">处理中</span>
                  </div>
                <div
                  class="complaint-data-subcard complaint-data-subcard--clickable"
                  @click="openComplaintDetail('month')"
                >
                  <span class="complaint-data-number">{{ complaintData.month.processing }}</span>
                  <span class="complaint-data-label">处理中</span>
                  </div>
                <div
                  class="complaint-data-subcard complaint-data-subcard--clickable"
                  @click="openComplaintDetail('today')"
                >
                  <span class="complaint-data-number">{{ complaintData.today.completed }}</span>
                  <span class="complaint-data-label">已完成</span>
                </div>
                <div
                  class="complaint-data-subcard complaint-data-subcard--clickable"
                  @click="openComplaintDetail('month')"
                >
                  <span class="complaint-data-number">{{ complaintData.month.completed }}</span>
                  <span class="complaint-data-label">已完成</span>
              </div>
                </div>
            </template>
            <template v-else>
              <div class="complaint-data-grid complaint-data-grid--three">
                  <div class="complaint-data-subcard">
                  <span class="complaint-data-number">{{ complaintData.today.total }}</span>
                  <span class="complaint-data-label">投诉数</span>
                  </div>
                  <div class="complaint-data-subcard">
                  <span class="complaint-data-number">{{ complaintData.today.processing }}</span>
                  <span class="complaint-data-label">处理中</span>
                  </div>
                <div class="complaint-data-subcard">
                  <span class="complaint-data-number">{{ complaintData.today.completed }}</span>
                  <span class="complaint-data-label">已完成</span>
              </div>
            </div>
            </template>
          </div>
        </div>

        <!-- 底部数据块 -->
        <div class="bottom-grid">
          <a-row :gutter="[16, 16]">
            <a-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" :xxl="8">
              <div class="panel-card panel-fixed">
                <div class="panel-header">
                  <span class="section-title">健康数据</span>
                  <a-button-group class="filter-buttons">
                    <a-button
                      :type="healthPanelTab === 'alert' ? 'primary' : 'default'"
                      @click="switchHealthPanelTab('alert')"
                    >健康异常</a-button>
                    <a-button
                      :type="healthPanelTab === 'data' ? 'primary' : 'default'"
                      @click="switchHealthPanelTab('data')"
                    >健康数据</a-button>
                  </a-button-group>
                </div>
                <div class="panel-body scrollable health-panel-body">
                  <div class="health-panel-table-wrap">
                    <a-table
                      :columns="healthPanelTableColumns"
                      :data-source="healthPanelTableDataPaged"
                      :loading="healthPanelTab === 'alert' ? healthAlertLoading : healthWristbandLoading"
                      :locale="{ emptyText: '' }"
                      :pagination="false"
                      :row-key="getHealthPanelRowKey"
                      :scroll="{ x: 'max-content', y: panelTableScrollY }"
                      size="small"
                      :custom-row="getHealthAlertTableRowProps"
                    />
                  </div>
                    <a-pagination
                    v-if="healthPanelTotal > 0"
                    :current="healthPanelPageNum"
                    :page-size="healthPanelPageSize"
                    :total="healthPanelTotal"
                      show-size-changer
                    :page-size-options="['10', '20', '50']"
                      show-quick-jumper
                      size="small"
                    class="health-panel-pagination"
                    @change="handleHealthPanelPageChange"
                    @showSizeChange="handleHealthPanelSizeChange"
                  />
                  <a-empty
                    v-if="(healthPanelTab === 'alert' ? !healthAlertLoading && !healthAlertList.length : !healthWristbandLoading && !healthWristbandList.length)"
                    description="暂无数据"
                    class="panel-empty"
                  />
                </div>
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" :xxl="8">
              <div class="panel-card panel-fixed">
                <div class="panel-header">
                  <span class="section-title">最新消息</span>
                </div>
                <div class="panel-body scrollable message-panel-body">
                  <div class="message-panel-table-wrap">
                  <a-table
                      :columns="messageColumns"
                      :data-source="messageList"
                      :loading="messageLoading"
                    :pagination="false"
                      :row-key="getMessageRowKey"
                      :scroll="{ x: 'max-content', y: panelTableScrollY }"
                    size="small"
                  />
                  </div>
                  <a-pagination
                    v-if="messageTotal > 0"
                    :current="messagePageNum"
                    :page-size="messagePageSize"
                    :total="messageTotal"
                    show-size-changer
                    :page-size-options="['10', '20', '50']"
                    show-quick-jumper
                    size="small"
                    class="message-pagination"
                    @change="handleMessagePageChange"
                    @showSizeChange="handleMessageSizeChange"
                  />
                  <a-empty v-if="!messageLoading && !messageList.length" description="暂无数据" class="panel-empty" />
                </div>
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" :xxl="8">
              <div class="panel-card panel-fixed">
                <div class="panel-header">
                  <span class="section-title">今日步数排行</span>
                  <small class="update-time"
                    >{{ stepRank.updateTime }} 更新</small
                  >
                </div>
                <div class="panel-body scrollable step-rank-panel-body">
                  <template v-if="stepRank.items && stepRank.items.length">
                    <ul class="rank-list">
                      <li v-for="item in stepRank.items" :key="item.rank">
                        <span class="rank-num" :class="'rk-' + item.rank">{{
                          item.rank
                        }}</span>
                        <img
                          :src="item.avatar || defaultStepAvatar"
                          alt="avatar"
                          @error="onStepAvatarError"
                        />
                        <div class="rank-info">
                          <p class="name">{{ item.name }}</p>
                          <p class="desc">{{ item.project }}</p>
                        </div>
                        <span class="rank-step">{{ item.steps }}步</span>
                      </li>
                    </ul>
                  </template>
                  <a-empty v-else description="暂无数据" class="panel-empty" />
                </div>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>

      <!-- 任务详情弹窗 -->
      <a-modal
        :visible="taskDetailVisible"
        :footer="null"
        width="1100px"
        title="任务详情"
        :body-style="{ paddingTop: '0px' }"
        @cancel="handleTaskDetailClose"
      >
        <div class="task-detail-header detail-header-single-line">
          <div class="task-detail-header-row">
            <a-button-group class="filter-buttons">
              <a-button
                :type="taskDetailFilterType === 'today' ? 'primary' : 'default'"
                @click="handleTaskDetailFilterChange('today')"
                >今日</a-button
              >
              <a-button
                :type="taskDetailFilterType === 'week' ? 'primary' : 'default'"
                @click="handleTaskDetailFilterChange('week')"
                >本周</a-button
              >
              <a-button
                :type="taskDetailFilterType === 'month' ? 'primary' : 'default'"
                @click="handleTaskDetailFilterChange('month')"
                >本月</a-button
              >
            </a-button-group>
            <div class="task-detail-header-right">
              <a-radio-group
                v-model:value="taskDetailFilterType"
                button-style="solid"
                @change="handleTaskDetailFilterChange('custom')"
                class="custom-date-radio task-detail-custom-date-radio"
              >
                <a-radio-button value="custom">自定义</a-radio-button>
              </a-radio-group>
              <a-range-picker
                v-model:value="taskDetailDateRange"
                :disabled-date="disableFutureDate"
                format="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD"
                :placeholder="['开始时间', '结束时间']"
                inputReadOnly
                allow-clear
                class="task-detail-date-picker"
                @change="handleTaskDetailDateRangeChange"
              />
        </div>
      </div>
          <div class="task-detail-header-row task-detail-status-row">
            <span class="task-detail-filter-label">当前进度</span>
            <a-select
              v-model:value="taskDetailStatusFilter"
              placeholder="全部"
              allow-clear
              class="task-detail-status-select"
              style="width: 120px; border-radius: 4px"
              @change="handleTaskDetailStatusFilterChange"
            >
              <a-select-option value="">全部</a-select-option>
              <a-select-option :value="3">待定</a-select-option>
              <a-select-option :value="0">未开始</a-select-option>
              <a-select-option :value="1">进行中</a-select-option>
              <a-select-option :value="2">已完成</a-select-option>
            </a-select>
            <span class="task-detail-filter-label">人员</span>
            <a-select
              v-model:value="taskDetailUserIds"
              mode="multiple"
              allow-clear
              show-search
              option-filter-prop="title"
              :max-tag-count="2"
              placeholder="人员 / 完成率"
              class="task-detail-user-select"
              @change="handleTaskDetailUserFilterChange"
            >
              <a-select-option
                v-for="u in taskDetailUserOptions"
                :key="u.userId"
                :value="u.userId"
                :title="`${u.nickname} ${formatTaskCompletionRate(u.completionRate)}`"
              >
                {{ u.nickname }} {{ formatTaskCompletionRate(u.completionRate) }}
              </a-select-option>
            </a-select>
            <a-button
              type="primary"
              ghost
              :loading="taskDetailExportLoading"
              @click="handleTaskDetailExport"
            >导出</a-button>
    </div>
    </div>
        <a-table
          :columns="taskDetailColumns"
          :data-source="taskDetailData"
          :loading="taskDetailLoading"
          :pagination="false"
          :row-key="getTaskDetailRowKey"
          :scroll="{ x: 'max-content' }"
        />
        <div class="task-detail-footer-pagination-wrapper">
          <a-pagination
            :current="taskDetailPageNum"
            :page-size="taskDetailPageSize"
            :total="taskDetailTotal"
            show-size-changer
            show-quick-jumper
            @change="handleTaskDetailPageChange"
            @showSizeChange="handleTaskDetailSizeChange"
            class="task-detail-footer-pagination"
          />
        </div>
      </a-modal>

      <!-- 手环详情弹窗 -->
      <a-modal
        :visible="wristbandDetailVisible"
        :footer="null"
        width="1100px"
        title="手环详情"
        :body-style="{ paddingTop: '0px' }"
        @cancel="handleWristbandDetailClose"
      >
        <div class="task-detail-header detail-header-single-line">
          <a-button-group class="filter-buttons">
            <a-button
              :type="wristbandDetailFilterType === 'today' ? 'primary' : 'default'"
              @click="handleWristbandDetailFilterChange('today')"
              >今日</a-button
            >
            <a-button
              :type="wristbandDetailFilterType === 'week' ? 'primary' : 'default'"
              @click="handleWristbandDetailFilterChange('week')"
              >本周</a-button
            >
            <a-button
              :type="wristbandDetailFilterType === 'month' ? 'primary' : 'default'"
              @click="handleWristbandDetailFilterChange('month')"
              >本月</a-button
            >
          </a-button-group>
          <div class="task-detail-header-right">
            <a-radio-group
              v-model:value="wristbandDetailFilterType"
              button-style="solid"
              @change="handleWristbandDetailFilterChange('custom')"
              class="custom-date-radio wristband-detail-custom-date-radio"
            >
              <a-radio-button value="custom">自定义</a-radio-button>
            </a-radio-group>
            <a-range-picker
              v-model:value="wristbandDetailDateRange"
              :disabled-date="disableFutureDate"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              :placeholder="['开始时间', '结束时间']"
              inputReadOnly
              allow-clear
              class="task-detail-date-picker"
              @change="handleWristbandDetailDateRangeChange"
            />
          </div>
        </div>
        <a-table
          :columns="wristbandDetailColumns"
          :data-source="wristbandDetailData"
          :loading="wristbandDetailLoading"
          :pagination="false"
          :row-key="getWristbandDetailRowKey"
          :scroll="{ x: 'max-content' }"
        />
        <div class="task-detail-footer-pagination-wrapper">
          <a-pagination
            :current="wristbandDetailPageNum"
            :page-size="wristbandDetailPageSize"
            :total="wristbandDetailTotal"
            show-size-changer
            show-quick-jumper
            @change="handleWristbandDetailPageChange"
            @showSizeChange="handleWristbandDetailSizeChange"
            class="task-detail-footer-pagination"
          />
        </div>
      </a-modal>

      <!-- 出勤详情弹窗 -->
      <a-modal
        :visible="attendanceDetailVisible"
        :footer="null"
        width="1100px"
        title="出勤详情"
        :body-style="{ paddingTop: '0px' }"
        @cancel="handleAttendanceDetailClose"
      >
        <div class="task-detail-header detail-header-single-line">
          <a-button-group class="filter-buttons">
            <a-button
              :type="attendanceDetailFilterType === 'today' ? 'primary' : 'default'"
              @click="handleAttendanceDetailFilterChange('today')"
              >今日</a-button
            >
            <a-button
              :type="attendanceDetailFilterType === 'week' ? 'primary' : 'default'"
              @click="handleAttendanceDetailFilterChange('week')"
              >本周</a-button
            >
            <a-button
              :type="attendanceDetailFilterType === 'month' ? 'primary' : 'default'"
              @click="handleAttendanceDetailFilterChange('month')"
              >本月</a-button
            >
          </a-button-group>
          <div class="task-detail-header-right">
            <a-button class="attendance-detail-custom-btn" @click="handleAttendanceDetailFilterChange('custom')">自定义</a-button>
            <a-range-picker
              v-model:value="attendanceDetailDateRange"
              :disabled-date="disableFutureDate"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              :placeholder="['开始时间', '结束时间']"
              inputReadOnly
              allow-clear
              class="task-detail-date-picker"
              @change="handleAttendanceDetailDateRangeChange"
            />
          </div>
        </div>
        <a-table
          :columns="attendanceDetailColumns"
          :data-source="attendanceDetailData"
          :loading="attendanceDetailLoading"
          :pagination="false"
          :row-key="getAttendanceDetailRowKey"
          :scroll="{ x: 'max-content' }"
        />
        <div class="task-detail-footer-pagination-wrapper">
          <a-pagination
            :current="attendanceDetailPageNum"
            :page-size="attendanceDetailPageSize"
            :total="attendanceDetailTotal"
            show-size-changer
            show-quick-jumper
            @change="handleAttendanceDetailPageChange"
            @showSizeChange="handleAttendanceDetailSizeChange"
            class="task-detail-footer-pagination"
          />
        </div>
      </a-modal>

      <!-- 投诉详情弹窗 -->
      <a-modal
        :visible="complaintDetailVisible"
        :footer="null"
        width="1100px"
        title="投诉详情"
        :body-style="{ paddingTop: '0px' }"
        @cancel="handleComplaintDetailClose"
      >
        <div class="task-detail-header detail-header-single-line">
          <a-button-group class="filter-buttons">
            <a-button
              :type="complaintDetailFilterType === 'today' ? 'primary' : 'default'"
              @click="handleComplaintDetailFilterChange('today')"
              >今日</a-button
            >
            <a-button
              :type="complaintDetailFilterType === 'week' ? 'primary' : 'default'"
              @click="handleComplaintDetailFilterChange('week')"
              >本周</a-button
            >
            <a-button
              :type="complaintDetailFilterType === 'month' ? 'primary' : 'default'"
              @click="handleComplaintDetailFilterChange('month')"
              >本月</a-button
            >
          </a-button-group>
          <div class="task-detail-header-right">
            <a-button class="complaint-detail-custom-btn" @click="handleComplaintDetailFilterChange('custom')">自定义</a-button>
            <a-range-picker
              v-model:value="complaintDetailDateRange"
              :disabled-date="disableFutureDate"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              :placeholder="['开始时间', '结束时间']"
              inputReadOnly
              allow-clear
              class="task-detail-date-picker"
              @change="handleComplaintDetailDateRangeChange"
            />
          </div>
        </div>
        <div class="task-detail-header-row task-detail-status-row">
          <span class="task-detail-filter-label">类型</span>
          <a-select
            v-model:value="complaintDetailTypeFilter"
            allow-clear
            placeholder="全部类型"
            style="width: 140px"
            @change="handleComplaintDetailExtraFilterChange"
          >
            <a-select-option value="0">投诉</a-select-option>
            <a-select-option value="1">任务需求</a-select-option>
            <a-select-option value="2">临时任务</a-select-option>
            <a-select-option value="3">巡检单</a-select-option>
          </a-select>
          <span class="task-detail-filter-label">状态</span>
          <a-select
            v-model:value="complaintDetailStatusFilter"
            allow-clear
            placeholder="全部状态"
            style="width: 120px"
            @change="handleComplaintDetailExtraFilterChange"
          >
            <a-select-option value="0">待处理</a-select-option>
            <a-select-option value="1">处理中</a-select-option>
            <a-select-option value="2">已完成</a-select-option>
          </a-select>
        </div>
        <a-table
          :columns="complaintDetailColumns"
          :data-source="complaintDetailData"
          :loading="complaintDetailLoading"
          :pagination="false"
          :row-key="getComplaintDetailRowKey"
          :scroll="{ x: 'max-content' }"
        />
        <div class="task-detail-footer-pagination-wrapper">
          <a-pagination
            :current="complaintDetailPageNum"
            :page-size="complaintDetailPageSize"
            :total="complaintDetailTotal"
            show-size-changer
            show-quick-jumper
            @change="handleComplaintDetailPageChange"
            @showSizeChange="handleComplaintDetailSizeChange"
            class="task-detail-footer-pagination"
          />
        </div>
      </a-modal>

      <!-- 健康详情弹窗 -->
      <a-modal
        :visible="healthAlertDetailVisible"
        :footer="null"
        width="1100px"
        title="健康详情"
        :body-style="{ paddingTop: '0px' }"
        @cancel="handleHealthAlertDetailClose"
      >
        <div class="task-detail-header">
          <a-button-group class="filter-buttons">
            <a-button
              :type="healthAlertDetailFilterType === 'today' ? 'primary' : 'default'"
              @click="handleHealthAlertDetailFilterChange('today')"
              >今日</a-button
            >
            <a-button
              :type="healthAlertDetailFilterType === 'week' ? 'primary' : 'default'"
              @click="handleHealthAlertDetailFilterChange('week')"
              >本周</a-button
            >
            <a-button
              :type="healthAlertDetailFilterType === 'month' ? 'primary' : 'default'"
              @click="handleHealthAlertDetailFilterChange('month')"
              >本月</a-button
            >
          </a-button-group>
          <div class="task-detail-header-right">
            <a-button @click="handleHealthAlertDetailFilterChange('custom')">自定义</a-button>
            <a-range-picker
              v-model:value="healthAlertDetailDateRange"
              :disabled="healthAlertDetailFilterType !== 'custom'"
              :disabled-date="disableFutureDate"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              :placeholder="['开始时间', '结束时间']"
              inputReadOnly
              allow-clear
              class="task-detail-date-picker"
              @change="handleHealthAlertDetailDateRangeChange"
            />
          </div>
        </div>
        <a-table
          :columns="healthAlertDetailColumns"
          :data-source="healthAlertDetailData"
          :loading="healthAlertDetailLoading"
          :locale="{ emptyText: '暂无数据' }"
          :pagination="false"
          :row-key="getHealthAlertDetailRowKey"
          :scroll="{ x: 'max-content' }"
        />
        <div class="task-detail-footer-pagination-wrapper">
          <a-pagination
            :current="healthAlertDetailPageNum"
            :page-size="healthAlertDetailPageSize"
            :total="healthAlertDetailTotal"
            show-size-changer
            show-quick-jumper
            @change="handleHealthAlertDetailPageChange"
            @showSizeChange="handleHealthAlertDetailSizeChange"
            class="task-detail-footer-pagination"
          />
        </div>
      </a-modal>
    </div>
  </page-header-wrapper>
</template>

<script>
import { h } from 'vue'
import { getInfo } from '@/api/login'
import { getProjectDashboard } from '@/api/user/projectInfo'
import { getTaskPage, getTaskUserOptions, getWristbandPage, getAttendancePage, getComplaintPage, getHealthAlertPage, getMessagePage } from '@/api/system/dept'
import * as echarts from 'echarts'
import moment from 'moment'

export default {
  name: 'DataDashboard',
  data() {
    return {
      // 当前选中的项目ID（页面内部使用，不影响Vuex全局状态）
      selectedProject: null,
      // 日期区间筛选
      dateRange: [],
      startTime: undefined,
      endTime: undefined,
      // 项目列表（从用户信息中获取）
      projectList: [],
      // 顶部任务数据卡片占位数据，等待接口覆盖
      summaryCards: [
        {
          title: '任务总数',
          value: 0,
          icon: 'bar-chart',
          isPercent: false,
        },
        {
          title: '当日任务',
          value: 0,
          icon: 'calendar',
          isPercent: false,
        },
        {
          title: '已完成',
          value: 0,
          icon: 'check-circle',
          isPercent: false,
        },
        {
          title: '进行中',
          value: 0,
          icon: 'clock-circle',
          isPercent: false,
        },
        {
          title: '未开始',
          value: 0,
          icon: 'minus-circle',
          isPercent: false,
        },
      ],
      // 手环数据环形图配置
      wristbandStats: {
        title: '手环数据',
        percent: 0,
        percentLabel: '在岗率',
        color: '#165DFF',
        list: [
          { label: '手环总数', value: 0 },
          { label: '今日在岗', value: 0 },
        ],
      },
      // 出勤数据环形图配置
      attendanceStats: {
        title: '出勤数据',
        percent: 0,
        percentLabel: '出勤率',
        color: '#165DFF',
        list: [
          { label: '今日应出勤', value: 0 },
          { label: '今日实际出勤', value: 0 },
        ],
      },
      // 投诉数据
      complaintData: {
        today: {
        total: 0,
          processing: 0,
          completed: 0,
        },
        month: {
        total: 0,
          processing: 0,
          completed: 0,
        },
      },
      complaintIsToday: true,
      // 健康数据（表格展示）：接口返回的原始数据，空时由 getDerivedHealthDataRows 生成一行
      healthDataFromApi: [],
      // 健康异常列表（与 companyDashboard 健康预警明细一致：getHealthAlertPage）
      healthAlertList: [],
      healthAlertLoading: false,
      // 健康数据 Tab：手环详情列表（字段&接口参照 companyDashboard 手环详情弹窗：getWristbandPage）
      healthWristbandList: [],
      healthWristbandLoading: false,
      healthWristbandTotal: 0,
      // 健康数据面板切换：'alert' 健康异常 | 'data' 健康数据
      healthPanelTab: 'alert',
      // 健康面板表格分页
      healthPanelPageNum: 1,
      healthPanelPageSize: 10,
      // 空间/信标数据（柱状图）
      spaceData: [
        {
          label: '信标数',
          value: 0,
        },
        {
          label: '空间数',
          value: 0,
        },
      ],
      // 今日步数排行
      stepRank: {
        updateTime: '',
        items: [],
      },
      // 步数排行默认头像（无头像或加载失败时使用）
      defaultStepAvatar:
        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23b0b0b0'%3E%3Cpath d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'/%3E%3C/svg%3E",
      // 最新消息列表（/system/dept/messagePage）
      messageList: [],
      messageLoading: false,
      messagePageNum: 1,
      messagePageSize: 10,
      messageTotal: 0,
      // 底部面板表格 body 固定滚动高度（与今日步数排行面板 350px 高度对齐）
      panelTableScrollY: 180,
      messageColumns: [
        { title: '序号', dataIndex: 'index', width: 60 },
        { title: '发送方', dataIndex: 'sendname', width: 60, ellipsis: true },
        { title: '接收方', dataIndex: 'receivename', width: 80, ellipsis: true },
        { title: '消息内容', dataIndex: 'content', width: 180, ellipsis: true },
        {
          title: '时间',
          dataIndex: 'createTime',
          width: 160
          
        },
      ],
      // 注释代码,customRender: (text) => text ? (moment(text).isValid() ? moment(text).format('YYYY-MM-DD HH:mm') : text) : '--',
      dashboardLoading: false,
      spaceChartInstance: null,
      wristbandChartInstance: null,
      attendanceChartInstance: null,
      // 任务详情弹窗
      taskDetailVisible: false,
      taskDetailLoading: false,
      taskDetailData: [],
      taskDetailPageNum: 1,
      taskDetailPageSize: 10,
      taskDetailTotal: 0,
      taskDetailFilterType: 'today',
      taskDetailDateRange: [],
      taskDetailStatusFilter: '', // 当前进度筛选：'' 全部，3 待定，0 未开始，1 进行中，2 已完成
      taskDetailUserIds: [],
      taskDetailUserOptions: [],
      taskDetailExportLoading: false,
      taskDetailStartTime: undefined,
      taskDetailEndTime: undefined,
      taskDetailColumns: [
        { title: '序号', dataIndex: 'index' },
        { title: '空间名称', dataIndex: 'spaceName' },
        { title: '员工', dataIndex: 'nickname' },
        { title: '服务时长', dataIndex: 'serviceMinutesText' },
        {
          title: '当前进度',
          dataIndex: 'taskStatusText',
          customRender: ({ text }) => {
            if (text === '已完成') {
              return h('span', { style: { color: '#52c41a' } }, text)
            }
            return text
          },
        },
        { title: '任务时间', dataIndex: 'taskTimeText' },
      ],
      // 手环详情弹窗
      wristbandDetailVisible: false,
      wristbandDetailLoading: false,
      wristbandDetailData: [],
      wristbandDetailPageNum: 1,
      wristbandDetailPageSize: 10,
      wristbandDetailTotal: 0,
      wristbandDetailFilterType: 'today',
      wristbandDetailDateRange: [],
      wristbandDetailStartTime: undefined,
      wristbandDetailEndTime: undefined,
      wristbandDetailColumns: [
        { title: '序号', dataIndex: 'index' },
        { title: '员工', dataIndex: 'employeeName' },
        { title: 'MAC码', dataIndex: 'mac' },
        { title: '心率(BPM)', dataIndex: 'heartbeat' },
        { title: '体温(℃)', dataIndex: 'temperature' },
        {
          title: '血压(mmHg)',
          key: 'bloodPressure',
          customRender: ({ record }) => {
            const s = record.systolicBp ?? '--'
            const d = record.diastolicBp ?? '--'
            return `${s}/${d}`
          },
        },
        { title: '健康更新时间', dataIndex: 'healthUpdateTime' },
      ],
      // 出勤详情弹窗
      attendanceDetailVisible: false,
      attendanceDetailLoading: false,
      attendanceDetailData: [],
      attendanceDetailPageNum: 1,
      attendanceDetailPageSize: 10,
      attendanceDetailTotal: 0,
      attendanceDetailFilterType: 'today',
      attendanceDetailDateRange: [],
      attendanceDetailStartTime: undefined,
      attendanceDetailEndTime: undefined,
      attendanceDetailColumns: [
        { title: '序号', dataIndex: 'index' },
        { title: '员工', dataIndex: 'employeeName' },
        { title: '当前位置', dataIndex: 'currentLocation' },
        { title: '位置更新时间', dataIndex: 'locationUpdateTime' },
        { title: '工作流', dataIndex: 'hasWorkflow' },
        { title: '启动', dataIndex: 'workflowStarted' },
      ],
      // 投诉详情弹窗
      complaintDetailVisible: false,
      complaintDetailLoading: false,
      complaintDetailData: [],
      complaintDetailPageNum: 1,
      complaintDetailPageSize: 10,
      complaintDetailTotal: 0,
      complaintDetailFilterType: 'today',
      complaintDetailDateRange: [],
      complaintDetailStartTime: undefined,
      complaintDetailEndTime: undefined,
      complaintDetailTypeFilter: undefined,
      complaintDetailStatusFilter: undefined,
      complaintDetailColumns: [
        { title: '序号', dataIndex: 'index' },
        { title: '空间名称', dataIndex: 'spaceName' },
        { title: '类型', dataIndex: 'typeText' },
        { title: '处理状态', dataIndex: 'complaintStatusText' },
        { title: '负责人', dataIndex: 'ownerName' },
        { title: '投诉时间', dataIndex: 'complaintTimeText' },
        { title: '投诉内容', dataIndex: 'descriptionText' },
      ],
      // 健康详情弹窗
      healthAlertDetailVisible: false,
      healthAlertDetailLoading: false,
      healthAlertDetailData: [],
      healthAlertDetailPageNum: 1,
      healthAlertDetailPageSize: 10,
      healthAlertDetailTotal: 0,
      healthAlertDetailFilterType: 'today',
      healthAlertDetailDateRange: [],
      healthAlertDetailStartTime: undefined,
      healthAlertDetailEndTime: undefined,
      healthAlertDetailColumns: [
        { title: '序号', dataIndex: 'index' },
        { title: '员工', dataIndex: 'employeeName' },
        { title: '预警类型', dataIndex: 'alertTypeText' },
        { title: '预警数据', dataIndex: 'alertDataText' },
        { title: '预警时间', dataIndex: 'alertTimeText' },
      ],
      // 健康数据 Tab 表格列（与 companyDashboard 一致）
      healthColumns: [
        { title: '项目名称', dataIndex: 'name', width: 120 },
        { title: '出勤人数', dataIndex: 'healthy' },
        { title: '健康预警次数', dataIndex: 'warning' },
      ],
      // 健康数据模块选中“健康数据”时：表格字段参照 companyDashboard 手环详情弹窗
      healthWristbandColumns: [
        { title: '序号', dataIndex: 'index', width: 60 },
        { title: '员工', dataIndex: 'employeeName', width: 90, ellipsis: true },
        { title: 'MAC码', dataIndex: 'mac', width: 140, ellipsis: true },
        { title: '心率(BPM)', dataIndex: 'heartbeat', width: 100 },
        { title: '体温(℃)', dataIndex: 'temperature', width: 90 },
        {
          title: '血压(mmHg)',
          key: 'bloodPressure',
          width: 120,
          customRender: ({ record }) => {
            const s = record.systolicBp ?? '--'
            const d = record.diastolicBp ?? '--'
            return `${s}/${d}`
          },
        },
        { title: '健康更新时间', dataIndex: 'healthUpdateTime', width: 160 },
      ],
    }
  },
  computed: {
    /** 健康数据表格数据源：优先用接口返回，为空时用当前项目手环/预警数据生成一行 */
    healthData() {
      if (this.healthDataFromApi && this.healthDataFromApi.length > 0) {
        return this.healthDataFromApi
      }
      return this.getDerivedHealthDataRows()
    },
    /** 健康面板当前 Tab 对应的表格数据 */
    healthPanelTableData() {
      return this.healthPanelTab === 'alert' ? this.healthAlertList : this.healthWristbandList
    },
    /** 健康面板当前 Tab 对应的表格列 */
    healthPanelTableColumns() {
      return this.healthPanelTab === 'alert'
        ? this.healthAlertDetailColumns
        : this.healthWristbandColumns
    },
    /** 健康面板表格总条数 */
    healthPanelTotal() {
      if (this.healthPanelTab === 'data') return this.healthWristbandTotal || 0
      return (this.healthAlertList || []).length
    },
    /** 健康面板当前页要展示的表格数据（前端分页） */
    healthPanelTableDataPaged() {
      // 健康异常：一次拉取后前端分页；健康数据（手环详情）：后端分页，直接展示当前页
      if (this.healthPanelTab === 'data') return this.healthWristbandList || []
      const list = this.healthAlertList || []
      const start = (this.healthPanelPageNum - 1) * this.healthPanelPageSize
      return list.slice(start, start + this.healthPanelPageSize)
    },
  },
  watch: {
    healthPanelTab() {
      this.healthPanelPageNum = 1
    },
  },
  mounted() {
    // 页面加载时获取项目列表
    this.loadProjectList()
    this.$nextTick(() => {
      // 初始化各类图表
      this.initSpaceChart()
      this.initWristbandChart()
      this.initAttendanceChart()
    })
  },
  beforeUnmount() {
    if (this.spaceChartInstance) {
      window.removeEventListener('resize', this.handleSpaceChartResize)
      this.spaceChartInstance.dispose()
      this.spaceChartInstance = null
    }
    if (this.wristbandChartInstance) {
      window.removeEventListener('resize', this.handleWristbandChartResize)
      this.wristbandChartInstance.dispose()
      this.wristbandChartInstance = null
    }
    if (this.attendanceChartInstance) {
      window.removeEventListener('resize', this.handleAttendanceChartResize)
      this.attendanceChartInstance.dispose()
      this.attendanceChartInstance = null
    }
  },
  watch: {
    spaceData: {
      handler() {
        this.updateSpaceChart()
      },
      deep: true,
    },
    wristbandStats: {
      handler() {
        this.updateWristbandChart()
      },
      deep: true,
    },
    attendanceStats: {
      handler() {
        this.updateAttendanceChart()
      },
      deep: true,
    },
  },
  methods: {
    /**
     * 加载项目列表
     * 从用户信息中获取项目列表，数据源与RightContent.vue相同
     */
    loadProjectList() {
      getInfo()
        .then((res) => {
        if (res.success && res.data) {
          // 从用户信息中获取项目列表
          const projectInfoList = res.data.projectInfoList || []
            this.projectList = Array.isArray(projectInfoList)
              ? projectInfoList
              : []

          // 如果项目列表为空，显示暂无数据
          if (this.projectList.length === 0) {
            this.clearDashboardData()
            return
          }

          // 默认选中第一个项目（如果有的话）
          if (this.projectList.length > 0 && !this.selectedProject) {
            this.selectedProject = this.projectList[0].id
              // 默认日期区间为当前日期
              const today = moment().format('YYYY-MM-DD')
              if (!this.dateRange || this.dateRange.length === 0) {
                this.dateRange = [today, today]
                this.startTime = today
                this.endTime = today
              }
            // 加载仪表盘数据
            this.loadDashboardData()
          }
        }
        })
        .catch(() => {
        this.projectList = []
        this.clearDashboardData()
      })
    },

    /**
     * 过滤项目选项
     * 支持按项目名称或项目代码搜索
     */
    filterProjectOption(input, option) {
      if (!input) return true
      const value = option.componentOptions.propsData.value
      const project = this.projectList.find((p) => p.id === value)
      if (project) {
        const searchText = input.toLowerCase()
        const chineseName = (project.chineseName || '').toLowerCase()
        const projectCode = (project.projectCode || '').toLowerCase()
        return (
          chineseName.indexOf(searchText) >= 0 ||
          projectCode.indexOf(searchText) >= 0
        )
      }
      return false
    },

    initSpaceChart() {
      // 使用 $nextTick 确保 DOM 更新完成
      this.$nextTick(() => {
        if (!this.$refs.spaceChart) {
          return
        }
        if (!this.spaceChartInstance) {
          this.spaceChartInstance = echarts.init(this.$refs.spaceChart)
          window.addEventListener('resize', this.handleSpaceChartResize)
        }
        this.updateSpaceChart()
      })
    },

    handleSpaceChartResize() {
      if (this.spaceChartInstance) {
        this.spaceChartInstance.resize()
      }
    },

    updateSpaceChart() {
      // 使用 $nextTick 确保 DOM 更新完成
      this.$nextTick(() => {
        // 检查数据是否有效
        if (
          !this.spaceData ||
          this.spaceData.length === 0 ||
          !this.spaceData.some((item) => item.value > 0)
        ) {
          // 如果图表实例存在，清空图表
          if (this.spaceChartInstance) {
            this.spaceChartInstance.clear()
          }
          return
        }

        // 确保 DOM 元素存在
        if (!this.$refs.spaceChart) {
          // 如果 DOM 元素还不存在，延迟重试
          setTimeout(() => {
            this.updateSpaceChart()
          }, 100)
          return
        }

        // 如果图表实例不存在或被销毁，重新初始化
        if (!this.spaceChartInstance) {
          try {
            this.spaceChartInstance = echarts.init(this.$refs.spaceChart)
            window.addEventListener('resize', this.handleSpaceChartResize)
          } catch (e) {
            console.error('初始化空间数据图表失败:', e)
            return
          }
        }

        const categories = this.spaceData.map((item) => item.label)
        const values = this.spaceData.map((item) => item.value)
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
            },
          },
          grid: {
            left: 20,
            right: 20,
            top: 40,
            bottom: 30,
            containLabel: true,
          },
          xAxis: {
            type: 'category',
            data: categories,
            axisLine: { lineStyle: { color: '#dcdfe6' } },
            axisTick: { alignWithLabel: true },
            axisLabel: {
              color: '#1f2533',
            },
          },
          yAxis: {
            type: 'value',
            max: (value) => Math.ceil(value.max / 20) * 20,
            splitLine: { lineStyle: { color: '#f1f3f7' } },
            axisLine: { show: false },
          },
          series: [
            {
              name: '数量',
              type: 'bar',
              data: values,
              barWidth: 29,
              itemStyle: {
                color: '#165DFF',
                borderRadius: [4, 4, 0, 0],
              },
              label: {
                show: true,
                position: 'top',
                color: '#3c6df0',
                fontWeight: 600,
              },
            },
          ],
        }

        try {
          this.spaceChartInstance.setOption(option, true) // 使用 notMerge=true 确保完全替换
          // 确保图表正确渲染
          this.spaceChartInstance.resize()
        } catch (e) {
          console.error('更新空间数据图表失败:', e)
        }
      })
    },

    initWristbandChart() {
      if (!this.$refs.wristbandChart) return
      if (!this.wristbandChartInstance) {
        this.wristbandChartInstance = echarts.init(this.$refs.wristbandChart)
        window.addEventListener('resize', this.handleWristbandChartResize)
      }
      this.updateWristbandChart()
    },

    handleWristbandChartResize() {
      this.wristbandChartInstance && this.wristbandChartInstance.resize()
    },

    updateWristbandChart() {
      // 如果图表实例不存在，先初始化
      if (!this.wristbandChartInstance) {
        this.initWristbandChart()
        // 如果初始化后仍然不存在，则返回
        if (!this.wristbandChartInstance) {
          return
        }
      }
      const option = this.buildDonutOption(this.wristbandStats)
      this.wristbandChartInstance.setOption(option)
    },

    initAttendanceChart() {
      if (!this.$refs.attendanceChart) return
      if (!this.attendanceChartInstance) {
        this.attendanceChartInstance = echarts.init(this.$refs.attendanceChart)
        window.addEventListener('resize', this.handleAttendanceChartResize)
      }
      this.updateAttendanceChart()
    },

    handleAttendanceChartResize() {
      this.attendanceChartInstance && this.attendanceChartInstance.resize()
    },

    updateAttendanceChart() {
      // 如果图表实例不存在，先初始化
      if (!this.attendanceChartInstance) {
        this.initAttendanceChart()
        // 如果初始化后仍然不存在，则返回
        if (!this.attendanceChartInstance) {
          return
        }
      }
      const option = this.buildDonutOption(this.attendanceStats)
      this.attendanceChartInstance.setOption(option)
    },

    buildDonutOption(stat) {
      const percent = Number(stat.percent) || 0
      return {
        tooltip: { show: false },
        series: [
          {
            type: 'pie',
            radius: ['68%', '88%'],
            silent: true,
            label: { show: false },
            data: [
              { value: percent, itemStyle: { color: stat.color } },
              { value: 100 - percent, itemStyle: { color: '#ecf1ff' } },
            ],
          },
        ],
        graphic: [
          {
            type: 'group',
            left: 'center',
            top: 'middle',
            children: [
              {
                type: 'text',
                style: {
                  text: `${percent}%`,
                  textAlign: 'center',
                  fill: '#1f2533',
                  fontSize: 18,
                  fontWeight: 600,
                },
                top: -8,
              },
              {
                type: 'text',
                style: {
                  text: stat.percentLabel || '',
                  textAlign: 'center',
                  fill: '#1f2533',
                  fontSize: 12,
                },
                top: 12,
              },
            ],
          },
        ],
      }
    },

    /**
     * 处理项目选择变化
     * 只更新页面内部状态，不影响Vuex全局状态
     */
    handleProjectChange(value) {
      this.selectedProject = value || null
      // 如果项目列表为空或没有选择项目，不请求接口，显示暂无数据
      if (
        !this.projectList ||
        this.projectList.length === 0 ||
        !this.selectedProject
      ) {
        this.clearDashboardData()
        return
      }
      // 项目变化时重新加载仪表盘数据
      this.loadDashboardData()
    },

    /**
     * 日期区间变化
     */
    handleDateChange(dates, dateStrings) {
      if (!dates || dates.length === 0) {
        this.startTime = undefined
        this.endTime = undefined
      } else {
        this.startTime = dateStrings[0] || undefined
        this.endTime = dateStrings[1] || undefined
      }
      this.loadDashboardData()
      this.syncOpenDetailModalsDate()
    },

    /**
     * 禁用未来日期
     */
    disableFutureDate(current) {
      if (!current) return false
      const currentTime = current.valueOf ? current.valueOf() : moment(current).valueOf()
      return currentTime > moment().endOf('day').valueOf()
    },

    /**
     * 加载仪表盘数据
     * 根据选中的项目ID加载对应的仪表盘数据
     */
    loadDashboardData() {
      // 如果项目列表为空或没有选择项目，不请求接口，显示暂无数据
      if (
        !this.projectList ||
        this.projectList.length === 0 ||
        !this.selectedProject
      ) {
        this.clearDashboardData()
        return
      }
      this.dashboardLoading = true
      this.messagePageNum = 1
      const params = { projectId: this.selectedProject }
      if (this.startTime) params.startTime = this.startTime
      if (this.endTime) params.endTime = this.endTime
      getProjectDashboard(params)
        .then((res) => {
          const data = res?.data !== undefined && res?.data !== null ? res.data : res || {}
          const cards = Array.isArray(data.summaryCards)
            ? data.summaryCards
            : []
          // 确保每个卡片都有 isPercent 字段
          this.summaryCards = cards.map((card) => ({
            ...card,
            isPercent: card.isPercent !== undefined ? card.isPercent : false,
          }))

          const defaultWristband = {
            title: '手环数据',
            percent: 0,
            percentLabel: '在岗率',
            color: '#165DFF',
            list: [],
          }
          this.wristbandStats = Object.assign(
            {},
            defaultWristband,
            data.wristbandStats || {}
          )
          // 确保颜色始终为 #165DFF
          this.wristbandStats.color = '#165DFF'
          if (!Array.isArray(this.wristbandStats.list)) {
            this.wristbandStats.list = []
          }

          const defaultAttendance = {
            title: '出勤数据',
            percent: 0,
            percentLabel: '出勤率',
            color: '#165DFF',
            list: [],
          }
          this.attendanceStats = Object.assign(
            {},
            defaultAttendance,
            data.attendanceStats || {}
          )
          // 确保颜色始终为 #165DFF
          this.attendanceStats.color = '#165DFF'
          if (!Array.isArray(this.attendanceStats.list)) {
            this.attendanceStats.list = []
          }

          const complaint = data.complaintData || {}
          const complaintToday = complaint.today || {}
          const complaintMonth = complaint.month || {}
          this.complaintData = {
            today: {
              total: complaintToday.total || 0,
              processing: complaintToday.processing || 0,
              completed: complaintToday.completed || 0,
            },
            month: {
              total: complaintMonth.total || 0,
              processing: complaintMonth.processing || 0,
              completed: complaintMonth.completed || 0,
            },
          }
          // isToday 为 true 全部显示，为 false 或未返回时只显示 投诉数/处理中/已完成 三栏
          const isToday = data.isToday !== undefined ? data.isToday : res.isToday
          this.complaintIsToday = isToday === true

          this.healthDataFromApi = Array.isArray(data.healthData)
            ? data.healthData
            : []
          this.spaceData = Array.isArray(data.spaceData) ? data.spaceData : []
          const stepRank = data.stepRank || {}
          this.stepRank = {
            updateTime: stepRank.updateTime || '',
            items: Array.isArray(stepRank.items) ? stepRank.items : [],
          }

          // 使用 $nextTick 确保 DOM 更新后再更新图表
          this.$nextTick(() => {
            this.updateSpaceChart()
            this.updateWristbandChart()
            this.updateAttendanceChart()
          })
          this.fetchHealthAlertList()
          this.fetchMessageList()
          if (this.healthPanelTab === 'data') {
            this.fetchHealthWristbandPage()
          }
        })
        .catch(() => {
          if (this.$message && typeof this.$message.error === 'function') {
            this.$message.error('加载仪表盘数据失败', 3)
          }
          this.clearDashboardData()
        })
        .finally(() => {
          this.dashboardLoading = false
        })
    },

    /** 拉取最新消息列表（/system/dept/messagePage） */
    fetchMessageList() {
      if (!this.selectedProject) {
        this.messageList = []
        this.messageTotal = 0
        return
      }
      this.messageLoading = true
      const params = {
        projectId: this.selectedProject,
        pageNum: this.messagePageNum,
        pageSize: this.messagePageSize,
      }
      if (this.startTime) params.startTime = this.startTime
      if (this.endTime) params.endTime = this.endTime
      getMessagePage(params)
        .then((res) => {
          const page = res?.data || {}
          const records = page.records || []
          const total = page.total ?? 0
          this.messageTotal = total
          this.messageList = records.map((item, index) => ({
            ...item,
            index: (this.messagePageNum - 1) * this.messagePageSize + index + 1,
          }))
        })
        .catch(() => {
          this.messageList = []
          this.messageTotal = 0
        })
        .finally(() => {
          this.messageLoading = false
        })
    },

    /** 最新消息表格行 key */
    getMessageRowKey(record, index) {
      return record.id ?? `message-${record.createTime || ''}-${index}`
    },

    /** 最新消息分页：页码变化 */
    handleMessagePageChange(page) {
      this.messagePageNum = page
      this.fetchMessageList()
    },
    /** 最新消息分页：每页条数变化 */
    handleMessageSizeChange(current, size) {
      this.messagePageNum = 1
      this.messagePageSize = size
      this.fetchMessageList()
    },

    /** 今日步数排行：头像加载失败时使用默认头像 */
    onStepAvatarError(e) {
      if (e.target.src !== this.defaultStepAvatar) {
        e.target.src = this.defaultStepAvatar
      }
    },

    /** 当接口未返回 healthData 时，用当前项目手环与健康预警数据生成一行（与 companyDashboard 列一致：项目名称、出勤人数、健康预警次数） */
    getDerivedHealthDataRows() {
      if (!this.selectedProject) return []
      const project = this.projectList.find((p) => p.id === this.selectedProject)
      const name = project
        ? (project.chineseName || project.projectCode || '当前项目')
        : '当前项目'
      const list = this.wristbandStats?.list || []
      const onlineItem = list.find((item) => item.label === '今日在岗')
      const healthy = onlineItem && (onlineItem.value !== undefined && onlineItem.value !== null) ? Number(onlineItem.value) : 0
      const warning = Array.isArray(this.healthAlertList) ? this.healthAlertList.length : 0
      return [{ name, healthy, warning }]
    },

    /** 健康面板表格行 key（异常用明细 key，健康数据用 name/index） */
    getHealthPanelRowKey(record, index) {
      if (this.healthPanelTab === 'alert') {
        return this.getHealthAlertDetailRowKey(record, index)
      }
      return record.id ?? record.mac ?? `health-wristband-${index}`
    },

    /** 健康面板表格行点击：健康异常 → 健康预警明细弹窗；健康数据 → 手环详情弹窗（与 companyDashboard 手环详情一致） */
    getHealthAlertTableRowProps(record) {
      const openDetail = () => {
        if (this.healthPanelTab === 'data') {
          this.openWristbandDetail()
        } else {
          this.openHealthAlertDetail(record)
        }
      }
      return {
        class: 'health-table-row--clickable',
        on: {
          click: openDetail,
        },
      }
    },

    /** 健康面板表格分页：页码变化 */
    handleHealthPanelPageChange(page) {
      this.healthPanelPageNum = page
      if (this.healthPanelTab === 'data') {
        this.fetchHealthWristbandPage()
      }
    },
    /** 健康面板表格分页：每页条数变化 */
    handleHealthPanelSizeChange(current, size) {
      this.healthPanelPageNum = 1
      this.healthPanelPageSize = size
      if (this.healthPanelTab === 'data') {
        this.fetchHealthWristbandPage()
      }
    },

    /** 切换健康面板 Tab（健康异常 / 健康数据），切换到健康数据时主动拉取手环分页 */
    switchHealthPanelTab(tab) {
      this.healthPanelTab = tab
      this.healthPanelPageNum = 1
      if (tab === 'data') {
        this.$nextTick(() => this.fetchHealthWristbandPage())
      }
    },

    /** 拉取健康异常列表，接口与 companyDashboard 健康预警明细一致 getHealthAlertPage */
    fetchHealthAlertList() {
      if (!this.selectedProject) {
        this.healthAlertList = []
        return
      }
      this.healthAlertLoading = true
      const params = {
        projectId: this.selectedProject,
        pageNum: 1,
        pageSize: 20,
      }
      if (this.startTime) params.startTime = this.startTime
      if (this.endTime) params.endTime = this.endTime
      getHealthAlertPage(params)
        .then((res) => {
          const page = res?.data || {}
          const records = page.records || []
          this.healthAlertList = records.map((item, index) =>
            this.normalizeHealthAlertDetailItem(item, index + 1)
          )
        })
        .catch(() => {
          this.healthAlertList = []
        })
        .finally(() => {
          this.healthAlertLoading = false
        })
    },

    /** 健康数据 Tab：拉取手环详情分页数据（接口参照 companyDashboard 手环详情弹窗：getWristbandPage） */
    fetchHealthWristbandPage() {
      if (!this.selectedProject) {
        this.healthWristbandList = []
        this.healthWristbandTotal = 0
        return
      }
      this.healthWristbandLoading = true
      const params = {
        projectId: this.selectedProject,
        pageNum: this.healthPanelPageNum,
        pageSize: this.healthPanelPageSize,
      }
      if (this.startTime) params.startTime = this.startTime
      if (this.endTime) params.endTime = this.endTime
      getWristbandPage(params)
        .then((res) => {
          // 与 companyDashboard 手环详情一致：支持 res.data 或 res 即为分页对象，支持 records/rows/list
          const page = res?.data !== undefined && res?.data !== null ? res.data : res || {}
          const raw = page.records ?? page.rows ?? page.list
          const records = Array.isArray(raw) ? raw : Array.isArray(res?.data) ? res.data : []
          this.healthWristbandTotal = Number(page.total) || Number(page.totalCount) || records.length
          const startIndex = (this.healthPanelPageNum - 1) * this.healthPanelPageSize
          this.healthWristbandList = records.map((item, index) =>
            this.normalizeHealthWristbandItem(item, startIndex + index + 1)
          )
        })
        .catch(() => {
          this.healthWristbandList = []
          this.healthWristbandTotal = 0
        })
        .finally(() => {
          this.healthWristbandLoading = false
        })
    },

    /** 健康数据 Tab（手环详情）行数据标准化，字段与 companyDashboard 手环详情弹窗一致 */
    normalizeHealthWristbandItem(item, index) {
      return {
        ...item,
        index,
        employeeName: item.employeeName || item.nickname || item.name || item.userName || '--',
        mac: item.mac || item.wristbandMac || '--',
        heartbeat:
          item.heartbeat !== undefined && item.heartbeat !== null
            ? item.heartbeat
            : item.heartRate !== undefined && item.heartRate !== null
              ? item.heartRate
              : item.heart ?? '--',
        systolicBp:
          item.systolicBp !== undefined && item.systolicBp !== null ? item.systolicBp : undefined,
        diastolicBp:
          item.diastolicBp !== undefined && item.diastolicBp !== null ? item.diastolicBp : undefined,
        temperature:
          item.temperature !== undefined && item.temperature !== null
            ? item.temperature
            : item.bodyTemperature || '--',
        healthUpdateTime: item.healthUpdateTime || item.updateTime || item.createTime || '--',
      }
    },

    /**
     * 获取卡片样式类
     */
    getCardClass(card) {
      const iconMap = {
        'bar-chart': 'card-blue',
        'clock-circle': 'card-orange',
        'check-circle': 'card-green',
        'pie-chart': 'card-red',
        'calendar': 'card-red',
        'minus-circle': 'card-gray',
      }
      return iconMap[card.icon] || ''
    },
    /**
     * 获取卡片图标背景颜色
     */
    getCardIconColor(card) {
      const colorMap = {
        'bar-chart': '#1890ff', // 蓝色
        'clock-circle': '#ff9800', // 橙色
        'check-circle': '#52c41a', // 绿色
        'pie-chart': '#ff4d4f', // 红色
        'calendar': '#ff4d4f',
        'minus-circle': '#91d5ff', // 浅蓝色
      }
      return colorMap[card.icon] || '#e8e8e8'
    },
    /**
     * 获取任务卡片图标图片
     */
    getTaskCardImage(card) {
      const title = card && card.title
      const icon = card && card.icon
      const imageMap = {
        '任务总数': require('@/assets/images/dashbord/5.png'),
        '当日任务': require('@/assets/images/dashbord/8.png'),
        '已完成': require('@/assets/images/dashbord/7.png'),
        '完成': require('@/assets/images/dashbord/7.png'),
        '完成率': require('@/assets/images/dashbord/8.png'),
        '进行中': require('@/assets/images/dashbord/6.png'),
        '未开始': require('@/assets/images/dashbord/9.png'),
      }
      if (title && imageMap[title]) {
        return imageMap[title]
      }
      const iconImageMap = {
        'bar-chart': imageMap['任务总数'],
        'calendar': imageMap['当日任务'],
        'check-circle': imageMap['已完成'],
        'clock-circle': imageMap['进行中'],
        'minus-circle': imageMap['未开始'],
        'pie-chart': imageMap['完成率'],
      }
      return (icon && iconImageMap[icon]) || imageMap['任务总数']
    },
    /** 根据任务数据卡片标题映射弹窗当前进度筛选值 */
    getTaskStatusByCard(card) {
      if (!card) return ''
      const titleStatusMap = {
        任务总数: '',
        当日任务: '',
        进行中: 1,
        完成: 2,
        已完成: 2,
        完成率: 2,
        未开始: 0,
        待定: 3,
      }
      if (Object.prototype.hasOwnProperty.call(titleStatusMap, card.title)) {
        return titleStatusMap[card.title]
      }
      if (card.taskStatus !== undefined && card.taskStatus !== null && card.taskStatus !== '') {
        return card.taskStatus
      }
      if (card.status !== undefined && card.status !== null && card.status !== '') {
        return card.status
      }
      return ''
    },
    /** 点击任务数据卡片打开任务详情弹窗 */
    openTaskDetail(card) {
      if (!this.selectedProject) {
        this.$message.warning('请先选择项目')
        return
      }
      this.taskDetailPageNum = 1
      this.taskDetailPageSize = 10
      this.taskDetailStatusFilter = this.getTaskStatusByCard(card)
      this.taskDetailUserIds = []
      this.taskDetailVisible = true
      this.applyDashboardDateToDetail('taskDetail')
      this.fetchTaskDetailUserOptions()
      this.fetchTaskDetail()
    },
    fetchTaskDetail() {
      if (!this.selectedProject) return
      this.taskDetailLoading = true
      const params = {
        projectId: this.selectedProject,
        pageNum: this.taskDetailPageNum,
        pageSize: this.taskDetailPageSize,
      }
      if (this.taskDetailStartTime) params.startTime = this.taskDetailStartTime
      if (this.taskDetailEndTime) params.endTime = this.taskDetailEndTime
      const statusVal = this.taskDetailStatusFilter
      if (statusVal !== '' && statusVal !== undefined && statusVal !== null) {
        const v = String(statusVal)
        params.taskStatus = v
        params.status = v
      }
      if (this.taskDetailUserIds && this.taskDetailUserIds.length > 0) {
        params.userIds = this.taskDetailUserIds
      }
      getTaskPage(params)
        .then((res) => {
          const page = res?.data || {}
          const records = page.records || []
          this.taskDetailTotal = page.total || 0
          const startIndex = (this.taskDetailPageNum - 1) * this.taskDetailPageSize
          this.taskDetailData = records.map((item, index) => ({
            index: startIndex + index + 1,
            taskNumber: item.taskNumber ?? item.taskName ?? '--',
            spaceName: item.spaceName || item.taskName || '--',
            nickname: item.nickname || item.employeeName || '--',
            serviceMinutesText:
              item.serviceMinutes !== undefined && item.serviceMinutes !== null
                ? `${item.serviceMinutes}`
                : item.duration || '--',
            taskStatusText: this.formatTaskStatus(item.taskStatus ?? item.status),
            taskTimeText:
              item.taskTime ||
              item.serviceTime ||
              item.startTime ||
              item.createTime ||
              '--',
            ...item,
          }))
        })
        .catch(() => {
          this.$message.error('获取任务详情失败')
        })
        .finally(() => {
          this.taskDetailLoading = false
        })
    },
    handleTaskDetailFilterChange(type) {
      this.taskDetailFilterType = type
      const today = moment().format('YYYY-MM-DD')
      let start, end
      switch (type) {
        case 'today':
          start = today
          end = today
          this.taskDetailDateRange = [start, end]
          break
        case 'week':
          start = moment().startOf('week').format('YYYY-MM-DD')
          end = moment().endOf('week').format('YYYY-MM-DD')
          this.taskDetailDateRange = [start, end]
          break
        case 'month':
          start = moment().startOf('month').format('YYYY-MM-DD')
          end = moment().endOf('month').format('YYYY-MM-DD')
          this.taskDetailDateRange = [start, end]
          break
        case 'custom':
          if (this.taskDetailDateRange && this.taskDetailDateRange.length === 2) {
            this.taskDetailStartTime = this.normalizeDateValue(this.taskDetailDateRange[0])
            this.taskDetailEndTime = this.normalizeDateValue(this.taskDetailDateRange[1])
          } else {
            this.taskDetailStartTime = undefined
            this.taskDetailEndTime = undefined
          }
          this.refreshTaskDetailUserFilter()
          this.fetchTaskDetail()
          return
      }
      this.taskDetailStartTime = start
      this.taskDetailEndTime = end
      this.refreshTaskDetailUserFilter()
      this.fetchTaskDetail()
    },
    handleTaskDetailDateRangeChange(dates, dateStrings) {
      if (!dates || dates.length === 0) {
        this.taskDetailStartTime = undefined
        this.taskDetailEndTime = undefined
      } else {
        this.taskDetailStartTime = dateStrings[0] || undefined
        this.taskDetailEndTime = dateStrings[1] || undefined
      }
      if (this.taskDetailFilterType === 'custom') {
        this.refreshTaskDetailUserFilter()
        this.fetchTaskDetail()
      }
    },
    handleTaskDetailPageChange(page, pageSize) {
      this.taskDetailPageNum = page
      this.taskDetailPageSize = pageSize
      this.fetchTaskDetail()
    },
    handleTaskDetailSizeChange(current, size) {
      this.taskDetailPageNum = 1
      this.taskDetailPageSize = size
      this.fetchTaskDetail()
    },
    handleTaskDetailStatusFilterChange() {
      this.taskDetailPageNum = 1
      this.fetchTaskDetail()
    },
    handleTaskDetailUserFilterChange() {
      this.taskDetailPageNum = 1
      this.fetchTaskDetail()
    },
    formatTaskCompletionRate(rate) {
      const n = rate == null || rate === '' ? 0 : Number(rate)
      return `${Number.isNaN(n) ? 0 : n}%`
    },
    refreshTaskDetailUserFilter() {
      this.taskDetailUserIds = []
      this.fetchTaskDetailUserOptions()
    },
    fetchTaskDetailUserOptions() {
      if (!this.selectedProject) {
        this.taskDetailUserOptions = []
        return
      }
      const params = { projectId: this.selectedProject }
      if (this.taskDetailStartTime) params.startTime = this.taskDetailStartTime
      if (this.taskDetailEndTime) params.endTime = this.taskDetailEndTime
      getTaskUserOptions(params)
        .then((res) => {
          this.taskDetailUserOptions = (res && res.data) ? res.data : []
        })
        .catch(() => {
          this.taskDetailUserOptions = []
        })
    },
    handleTaskDetailExport() {
      if (!this.selectedProject) {
        this.$message.warning('请先选择项目')
        return
      }
      const that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '将导出当前筛选条件下的全部任务详情',
        onOk() {
          that.taskDetailExportLoading = true
          const params = { projectId: that.selectedProject }
          if (that.taskDetailStartTime) params.startTime = that.taskDetailStartTime
          if (that.taskDetailEndTime) params.endTime = that.taskDetailEndTime
          const statusVal = that.taskDetailStatusFilter
          if (statusVal !== '' && statusVal !== undefined && statusVal !== null) {
            params.taskStatus = statusVal
          }
          if (that.taskDetailUserIds && that.taskDetailUserIds.length > 0) {
            params.userIds = that.taskDetailUserIds
          }
          return that.download(
            'system/dept/taskExport',
            params,
            `任务详情_${new Date().getTime()}.xlsx`
          ).finally(() => {
            that.taskDetailExportLoading = false
          })
        },
      })
    },
    handleTaskDetailClose() {
      this.taskDetailVisible = false
      this.taskDetailData = []
      this.taskDetailPageNum = 1
      this.taskDetailPageSize = 10
      this.taskDetailTotal = 0
      this.taskDetailFilterType = 'today'
      this.taskDetailDateRange = []
      this.taskDetailStatusFilter = ''
      this.taskDetailUserIds = []
      this.taskDetailUserOptions = []
      this.taskDetailExportLoading = false
      this.taskDetailStartTime = undefined
      this.taskDetailEndTime = undefined
    },
    normalizeDateValue(value) {
      if (!value) return undefined
      if (typeof value === 'string') return value
      if (value.format) return value.format('YYYY-MM-DD')
      return undefined
    },
    /** 获取页面顶部时间筛选范围 */
    getDashboardDateRange() {
      const today = moment().format('YYYY-MM-DD')
      const start = this.startTime || today
      const end = this.endTime || today
      return { start, end, dateRange: [start, end] }
    },
    /** 根据起止日期推断弹窗快捷筛选类型 */
    resolveDateFilterType(start, end) {
      const today = moment().format('YYYY-MM-DD')
      if (start === today && end === today) return 'today'
      const weekStart = moment().startOf('week').format('YYYY-MM-DD')
      const weekEnd = moment().endOf('week').format('YYYY-MM-DD')
      if (start === weekStart && end === weekEnd) return 'week'
      const monthStart = moment().startOf('month').format('YYYY-MM-DD')
      const monthEnd = moment().endOf('month').format('YYYY-MM-DD')
      if (start === monthStart && end === monthEnd) return 'month'
      return 'custom'
    },
    /** 将页面顶部时间同步到指定详情弹窗 */
    applyDashboardDateToDetail(prefix) {
      const { start, end, dateRange } = this.getDashboardDateRange()
      this[`${prefix}FilterType`] = this.resolveDateFilterType(start, end)
      this[`${prefix}DateRange`] = [...dateRange]
      this[`${prefix}StartTime`] = start
      this[`${prefix}EndTime`] = end
    },
    /** 页面顶部时间变更时，同步已打开的详情弹窗 */
    syncOpenDetailModalsDate() {
      const modalDefs = [
        { visible: 'taskDetailVisible', prefix: 'taskDetail', fetch: 'fetchTaskDetail', pageNum: 'taskDetailPageNum' },
        { visible: 'wristbandDetailVisible', prefix: 'wristbandDetail', fetch: 'fetchWristbandDetail', pageNum: 'wristbandDetailPageNum' },
        { visible: 'attendanceDetailVisible', prefix: 'attendanceDetail', fetch: 'fetchAttendanceDetail', pageNum: 'attendanceDetailPageNum' },
        { visible: 'complaintDetailVisible', prefix: 'complaintDetail', fetch: 'fetchComplaintDetail', pageNum: 'complaintDetailPageNum' },
        { visible: 'healthAlertDetailVisible', prefix: 'healthAlertDetail', fetch: 'fetchHealthAlertDetail', pageNum: 'healthAlertDetailPageNum' },
      ]
      modalDefs.forEach(({ visible, prefix, fetch, pageNum }) => {
        if (this[visible]) {
          this[pageNum] = 1
          this.applyDashboardDateToDetail(prefix)
          this[fetch]()
        }
      })
    },
    formatTaskStatus(status) {
      const statusMap = { 3: '待定', 0: '未开始', 1: '进行中', 2: '已完成' }
      return statusMap[status] || statusMap[String(status)] || status || '--'
    },
    getTaskDetailRowKey(record, index) {
      return (
        record.id ||
        `${record.taskNumber || index}-${record.spaceName || ''}-${record.nickname || ''}-${index}`
      )
    },
    disableFutureDate(current) {
      if (!current) return false
      const t =
        typeof current.valueOf === 'function'
          ? current.valueOf()
          : moment(current, 'YYYY-MM-DD').valueOf()
      return t > moment().endOf('day').valueOf()
    },
    /** 点击手环数据项打开手环详情弹窗 */
    openWristbandDetail() {
      if (!this.selectedProject) {
        this.$message.warning('请先选择项目')
        return
      }
      this.wristbandDetailPageNum = 1
      this.wristbandDetailPageSize = 10
      this.wristbandDetailVisible = true
      this.applyDashboardDateToDetail('wristbandDetail')
      this.fetchWristbandDetail()
    },
    fetchWristbandDetail() {
      if (!this.selectedProject) return
      this.wristbandDetailLoading = true
      const params = {
        projectId: this.selectedProject,
        pageNum: this.wristbandDetailPageNum,
        pageSize: this.wristbandDetailPageSize,
      }
      if (this.wristbandDetailStartTime) params.startTime = this.wristbandDetailStartTime
      if (this.wristbandDetailEndTime) params.endTime = this.wristbandDetailEndTime
      getWristbandPage(params)
        .then((res) => {
          const page = res?.data || {}
          const records = page.records || []
          this.wristbandDetailTotal = page.total || 0
          this.wristbandDetailData = records.map((item, index) =>
            this.normalizeWristbandDetailItem(
              item,
              (this.wristbandDetailPageNum - 1) * this.wristbandDetailPageSize + index + 1
            )
          )
        })
        .catch(() => {
          this.$message.error('获取手环详情失败')
        })
        .finally(() => {
          this.wristbandDetailLoading = false
        })
    },
    normalizeWristbandDetailItem(item, index) {
      return this.normalizeHealthWristbandItem(item, index)
    },
    handleWristbandDetailFilterChange(type) {
      this.wristbandDetailFilterType = type
      const today = moment().format('YYYY-MM-DD')
      let start, end
      switch (type) {
        case 'today':
          start = today
          end = today
          this.wristbandDetailDateRange = [start, end]
          break
        case 'week':
          start = moment().startOf('week').format('YYYY-MM-DD')
          end = moment().endOf('week').format('YYYY-MM-DD')
          this.wristbandDetailDateRange = [start, end]
          break
        case 'month':
          start = moment().startOf('month').format('YYYY-MM-DD')
          end = moment().endOf('month').format('YYYY-MM-DD')
          this.wristbandDetailDateRange = [start, end]
          break
        case 'custom':
          if (this.wristbandDetailDateRange && this.wristbandDetailDateRange.length === 2) {
            this.wristbandDetailStartTime = this.normalizeDateValue(
              this.wristbandDetailDateRange[0]
            )
            this.wristbandDetailEndTime = this.normalizeDateValue(
              this.wristbandDetailDateRange[1]
            )
          } else {
            this.wristbandDetailStartTime = undefined
            this.wristbandDetailEndTime = undefined
          }
          this.fetchWristbandDetail()
          return
      }
      this.wristbandDetailStartTime = start
      this.wristbandDetailEndTime = end
      this.fetchWristbandDetail()
    },
    handleWristbandDetailDateRangeChange(dates, dateStrings) {
      if (!dates || dates.length === 0) {
        this.wristbandDetailStartTime = undefined
        this.wristbandDetailEndTime = undefined
      } else {
        this.wristbandDetailStartTime = dateStrings[0] || undefined
        this.wristbandDetailEndTime = dateStrings[1] || undefined
      }
      if (this.wristbandDetailFilterType === 'custom') {
        this.fetchWristbandDetail()
      }
    },
    handleWristbandDetailPageChange(page, pageSize) {
      this.wristbandDetailPageNum = page
      this.wristbandDetailPageSize = pageSize
      this.fetchWristbandDetail()
    },
    handleWristbandDetailSizeChange(current, size) {
      this.wristbandDetailPageNum = 1
      this.wristbandDetailPageSize = size
      this.fetchWristbandDetail()
    },
    getWristbandDetailRowKey(record, index) {
      return (
        record.id ||
        `${record.employeeName || record.nickname || index}-${record.mac || ''}-${index}`
      )
    },
    handleWristbandDetailClose() {
      this.wristbandDetailVisible = false
      this.wristbandDetailData = []
      this.wristbandDetailPageNum = 1
      this.wristbandDetailPageSize = 10
      this.wristbandDetailTotal = 0
      this.wristbandDetailFilterType = 'today'
      this.wristbandDetailDateRange = []
      this.wristbandDetailStartTime = undefined
      this.wristbandDetailEndTime = undefined
    },
    /** 点击出勤数据项打开出勤详情弹窗 */
    openAttendanceDetail() {
      if (!this.selectedProject) {
        this.$message.warning('请先选择项目')
        return
      }
      this.attendanceDetailPageNum = 1
      this.attendanceDetailPageSize = 10
      this.attendanceDetailVisible = true
      this.applyDashboardDateToDetail('attendanceDetail')
      this.fetchAttendanceDetail()
    },
    fetchAttendanceDetail() {
      if (!this.selectedProject) return
      this.attendanceDetailLoading = true
      const params = {
        projectId: this.selectedProject,
        pageNum: this.attendanceDetailPageNum,
        pageSize: this.attendanceDetailPageSize,
      }
      if (this.attendanceDetailStartTime) params.startTime = this.attendanceDetailStartTime
      if (this.attendanceDetailEndTime) params.endTime = this.attendanceDetailEndTime
      getAttendancePage(params)
        .then((res) => {
          const page = res?.data || {}
          const records = page.records || []
          this.attendanceDetailTotal = page.total || 0
          this.attendanceDetailData = records.map((item, index) =>
            this.normalizeAttendanceDetailItem(
              item,
              (this.attendanceDetailPageNum - 1) * this.attendanceDetailPageSize + index + 1
            )
          )
        })
        .catch(() => {
          this.$message.error('获取出勤详情失败')
        })
        .finally(() => {
          this.attendanceDetailLoading = false
        })
    },
    normalizeAttendanceDetailItem(item, index) {
      return {
        ...item,
        index,
        employeeName:
          item.employeeName || item.nickname || item.name || item.userName || '--',
        currentLocation:
          item.currentLocation ||
          item.locationName ||
          item.positionName ||
          item.spaceName ||
          item.jobName ||
          '--',
        locationUpdateTime:
          item.uploadTime || item.updateTime || item.createTime || '--',
        hasWorkflow: item.hasWorkflow != null && item.hasWorkflow !== '' ? item.hasWorkflow : '-',
        workflowStarted: item.workflowStarted != null && item.workflowStarted !== '' ? item.workflowStarted : '-',
      }
    },
    handleAttendanceDetailFilterChange(type) {
      this.attendanceDetailFilterType = type
      const today = moment().format('YYYY-MM-DD')
      let start, end
      switch (type) {
        case 'today':
          start = today
          end = today
          this.attendanceDetailDateRange = [start, end]
          break
        case 'week':
          start = moment().startOf('week').format('YYYY-MM-DD')
          end = moment().endOf('week').format('YYYY-MM-DD')
          this.attendanceDetailDateRange = [start, end]
          break
        case 'month':
          start = moment().startOf('month').format('YYYY-MM-DD')
          end = moment().endOf('month').format('YYYY-MM-DD')
          this.attendanceDetailDateRange = [start, end]
          break
        case 'custom':
          if (this.attendanceDetailDateRange && this.attendanceDetailDateRange.length === 2) {
            this.attendanceDetailStartTime = this.normalizeDateValue(
              this.attendanceDetailDateRange[0]
            )
            this.attendanceDetailEndTime = this.normalizeDateValue(
              this.attendanceDetailDateRange[1]
            )
          } else {
            this.attendanceDetailStartTime = undefined
            this.attendanceDetailEndTime = undefined
          }
          this.fetchAttendanceDetail()
          return
      }
      this.attendanceDetailStartTime = start
      this.attendanceDetailEndTime = end
      this.fetchAttendanceDetail()
    },
    handleAttendanceDetailDateRangeChange(dates, dateStrings) {
      if (!dates || dates.length === 0) {
        this.attendanceDetailStartTime = undefined
        this.attendanceDetailEndTime = undefined
      } else {
        this.attendanceDetailStartTime = dateStrings[0] || undefined
        this.attendanceDetailEndTime = dateStrings[1] || undefined
      }
      if (this.attendanceDetailFilterType === 'custom') {
        this.fetchAttendanceDetail()
      }
    },
    handleAttendanceDetailPageChange(page, pageSize) {
      this.attendanceDetailPageNum = page
      this.attendanceDetailPageSize = pageSize
      this.fetchAttendanceDetail()
    },
    handleAttendanceDetailSizeChange(current, size) {
      this.attendanceDetailPageNum = 1
      this.attendanceDetailPageSize = size
      this.fetchAttendanceDetail()
    },
    getAttendanceDetailRowKey(record, index) {
      return (
        record.userId ||
        record.id ||
        `${record.employeeName || record.nickname || index}-${record.currentLocation || ''}-${index}`
      )
    },
    handleAttendanceDetailClose() {
      this.attendanceDetailVisible = false
      this.attendanceDetailData = []
      this.attendanceDetailPageNum = 1
      this.attendanceDetailPageSize = 10
      this.attendanceDetailTotal = 0
      this.attendanceDetailFilterType = 'today'
      this.attendanceDetailDateRange = []
      this.attendanceDetailStartTime = undefined
      this.attendanceDetailEndTime = undefined
    },
    /** 点击投诉数据项打开投诉详情弹窗，scope: 'today' | 'month' */
    openComplaintDetail(scope) {
      if (!this.selectedProject) {
        this.$message.warning('请先选择项目')
        return
      }
      this.complaintDetailPageNum = 1
      this.complaintDetailPageSize = 10
      this.complaintDetailVisible = true
      this.applyDashboardDateToDetail('complaintDetail')
      this.fetchComplaintDetail()
    },
    fetchComplaintDetail() {
      if (!this.selectedProject) return
      this.complaintDetailLoading = true
      const params = {
        projectId: this.selectedProject,
        pageNum: this.complaintDetailPageNum,
        pageSize: this.complaintDetailPageSize,
      }
      if (this.complaintDetailStartTime) params.startTime = this.complaintDetailStartTime
      if (this.complaintDetailEndTime) params.endTime = this.complaintDetailEndTime
      if (this.complaintDetailTypeFilter !== undefined && this.complaintDetailTypeFilter !== null && this.complaintDetailTypeFilter !== '') {
        params.type = this.complaintDetailTypeFilter
      }
      if (this.complaintDetailStatusFilter !== undefined && this.complaintDetailStatusFilter !== null && this.complaintDetailStatusFilter !== '') {
        params.complaintStatus = this.complaintDetailStatusFilter
      }
      getComplaintPage(params)
        .then((res) => {
          const page = res?.data || {}
          const records = page.records || []
          this.complaintDetailTotal = page.total || 0
          this.complaintDetailData = records.map((item, index) =>
            this.normalizeComplaintDetailItem(
              item,
              (this.complaintDetailPageNum - 1) * this.complaintDetailPageSize + index + 1
            )
          )
        })
        .catch(() => {
          this.$message.error('获取投诉详情失败')
        })
        .finally(() => {
          this.complaintDetailLoading = false
        })
    },
    formatComplaintStatus(status) {
      const statusMap = { 0: '待处理', 1: '处理中', 2: '已完成' }
      return statusMap[status] ?? statusMap[String(status)] ?? status ?? '--'
    },
    formatComplaintType(type) {
      const typeMap = { 0: '投诉', 1: '任务需求', 2: '临时任务', 3: '巡检单' }
      return typeMap[type] || typeMap[String(type)] || type || '--'
    },
    handleComplaintDetailExtraFilterChange() {
      this.complaintDetailPageNum = 1
      this.fetchComplaintDetail()
    },
    normalizeComplaintDetailItem(item, index) {
      return {
        index,
        spaceName: item.spaceName || item.name || '--',
        typeText: this.formatComplaintType(item.type),
        complaintStatusText: this.formatComplaintStatus(
          item.complaintStatus ?? item.status
        ),
        ownerName:
          item.nickname ||
          item.supervisorName ||
          item.confirmName ||
          item.closingName ||
          '--',
        complaintTimeText:
          item.createTime || item.complaintTime || item.responseTime || '--',
        descriptionText: item.description || item.content || '--',
            ...item,
      }
    },
    handleComplaintDetailFilterChange(type) {
      this.complaintDetailFilterType = type
      const today = moment().format('YYYY-MM-DD')
      let start, end
      switch (type) {
        case 'today':
          start = today
          end = today
          this.complaintDetailDateRange = [start, end]
          break
        case 'week':
          start = moment().startOf('week').format('YYYY-MM-DD')
          end = moment().endOf('week').format('YYYY-MM-DD')
          this.complaintDetailDateRange = [start, end]
          break
        case 'month':
          start = moment().startOf('month').format('YYYY-MM-DD')
          end = moment().endOf('month').format('YYYY-MM-DD')
          this.complaintDetailDateRange = [start, end]
          break
        case 'custom':
          if (this.complaintDetailDateRange && this.complaintDetailDateRange.length === 2) {
            this.complaintDetailStartTime = this.normalizeDateValue(
              this.complaintDetailDateRange[0]
            )
            this.complaintDetailEndTime = this.normalizeDateValue(
              this.complaintDetailDateRange[1]
            )
          } else {
            this.complaintDetailStartTime = undefined
            this.complaintDetailEndTime = undefined
          }
          this.fetchComplaintDetail()
          return
      }
      this.complaintDetailStartTime = start
      this.complaintDetailEndTime = end
      this.fetchComplaintDetail()
    },
    handleComplaintDetailDateRangeChange(dates, dateStrings) {
      if (!dates || dates.length === 0) {
        this.complaintDetailStartTime = undefined
        this.complaintDetailEndTime = undefined
      } else {
        this.complaintDetailStartTime = dateStrings[0] || undefined
        this.complaintDetailEndTime = dateStrings[1] || undefined
      }
      if (this.complaintDetailFilterType === 'custom') {
        this.fetchComplaintDetail()
      }
    },
    handleComplaintDetailPageChange(page, pageSize) {
      this.complaintDetailPageNum = page
      this.complaintDetailPageSize = pageSize
      this.fetchComplaintDetail()
    },
    handleComplaintDetailSizeChange(current, size) {
      this.complaintDetailPageNum = 1
      this.complaintDetailPageSize = size
      this.fetchComplaintDetail()
    },
    getComplaintDetailRowKey(record, index) {
      return (
        record.id ||
        `${record.spaceName || index}-${record.description || record.content || ''}-${index}`
      )
    },
    handleComplaintDetailClose() {
      this.complaintDetailVisible = false
      this.complaintDetailData = []
      this.complaintDetailPageNum = 1
      this.complaintDetailPageSize = 10
      this.complaintDetailTotal = 0
      this.complaintDetailFilterType = 'today'
      this.complaintDetailDateRange = []
      this.complaintDetailStartTime = undefined
      this.complaintDetailEndTime = undefined
      this.complaintDetailTypeFilter = undefined
      this.complaintDetailStatusFilter = undefined
    },
    /** 点击健康数据行打开健康详情弹窗（按当前选中项目拉取） */
    openHealthAlertDetail() {
      if (!this.selectedProject) {
        this.$message.warning('请先选择项目')
        return
      }
      this.healthAlertDetailPageNum = 1
      this.healthAlertDetailPageSize = 10
      this.healthAlertDetailVisible = true
      this.applyDashboardDateToDetail('healthAlertDetail')
      this.fetchHealthAlertDetail()
    },
    fetchHealthAlertDetail() {
      if (!this.selectedProject) return
      this.healthAlertDetailLoading = true
      const params = {
        projectId: this.selectedProject,
        pageNum: this.healthAlertDetailPageNum,
        pageSize: this.healthAlertDetailPageSize,
      }
      if (this.healthAlertDetailStartTime) params.startTime = this.healthAlertDetailStartTime
      if (this.healthAlertDetailEndTime) params.endTime = this.healthAlertDetailEndTime
      getHealthAlertPage(params)
        .then((res) => {
          const page = res?.data || {}
          const records = page.records || []
          this.healthAlertDetailTotal = page.total || 0
          this.healthAlertDetailData = records.map((item, index) =>
            this.normalizeHealthAlertDetailItem(
              item,
              (this.healthAlertDetailPageNum - 1) * this.healthAlertDetailPageSize + index + 1
            )
          )
        })
        .catch(() => {
          this.$message.error('获取健康详情失败')
        })
        .finally(() => {
          this.healthAlertDetailLoading = false
        })
    },
    normalizeHealthAlertDetailItem(item, index) {
      return {
        index,
        employeeName:
          item.employeeName || item.nickname || item.name || item.userName || '--',
        alertTypeText: item.metricName || item.alertType || item.warningType || item.type || '--',
        alertDataText:
          item.metricData ||
          item.alertData ||
          item.warningData ||
          item.dataValue ||
          item.content ||
          '--',
        alertTimeText:
          item.uploadTime ||
          item.alertTime ||
          item.warningTime ||
          item.createTime ||
          item.updateTime ||
          '--',
        ...item,
      }
    },
    handleHealthAlertDetailFilterChange(type) {
      this.healthAlertDetailFilterType = type
      const today = moment().format('YYYY-MM-DD')
      let start, end
      switch (type) {
        case 'today':
          start = today
          end = today
          this.healthAlertDetailDateRange = [start, end]
          break
        case 'week':
          start = moment().startOf('week').format('YYYY-MM-DD')
          end = moment().endOf('week').format('YYYY-MM-DD')
          this.healthAlertDetailDateRange = [start, end]
          break
        case 'month':
          start = moment().startOf('month').format('YYYY-MM-DD')
          end = moment().endOf('month').format('YYYY-MM-DD')
          this.healthAlertDetailDateRange = [start, end]
          break
        case 'custom':
          if (this.healthAlertDetailDateRange && this.healthAlertDetailDateRange.length === 2) {
            this.healthAlertDetailStartTime = this.normalizeDateValue(
              this.healthAlertDetailDateRange[0]
            )
            this.healthAlertDetailEndTime = this.normalizeDateValue(
              this.healthAlertDetailDateRange[1]
            )
          } else {
            this.healthAlertDetailStartTime = undefined
            this.healthAlertDetailEndTime = undefined
          }
          this.fetchHealthAlertDetail()
          return
      }
      this.healthAlertDetailStartTime = start
      this.healthAlertDetailEndTime = end
      this.fetchHealthAlertDetail()
    },
    handleHealthAlertDetailDateRangeChange(dates, dateStrings) {
      if (!dates || dates.length === 0) {
        this.healthAlertDetailStartTime = undefined
        this.healthAlertDetailEndTime = undefined
      } else {
        this.healthAlertDetailStartTime = dateStrings[0] || undefined
        this.healthAlertDetailEndTime = dateStrings[1] || undefined
      }
      if (this.healthAlertDetailFilterType === 'custom') {
        this.fetchHealthAlertDetail()
      }
    },
    handleHealthAlertDetailPageChange(page, pageSize) {
      this.healthAlertDetailPageNum = page
      this.healthAlertDetailPageSize = pageSize
      this.fetchHealthAlertDetail()
    },
    handleHealthAlertDetailSizeChange(current, size) {
      this.healthAlertDetailPageNum = 1
      this.healthAlertDetailPageSize = size
      this.fetchHealthAlertDetail()
    },
    getHealthAlertDetailRowKey(record, index) {
      return (
        record.id ||
        `${record.employeeName || record.nickname || index}-${record.alertTime || record.createTime || ''}-${index}`
      )
    },
    handleHealthAlertDetailClose() {
      this.healthAlertDetailVisible = false
      this.healthAlertDetailData = []
      this.healthAlertDetailPageNum = 1
      this.healthAlertDetailPageSize = 10
      this.healthAlertDetailTotal = 0
      this.healthAlertDetailFilterType = 'today'
      this.healthAlertDetailDateRange = []
      this.healthAlertDetailStartTime = undefined
      this.healthAlertDetailEndTime = undefined
    },
    /**
     * 清空仪表盘数据
     * 当项目选择被清空时调用
     */
    clearDashboardData() {
      // 清空所有数据
      this.summaryCards = []
      this.wristbandStats = {
        title: '手环数据',
        percent: 0,
        percentLabel: '在岗率',
        color: '#2E8CF7',
        list: [
          { label: '手环总数', value: 0 },
          { label: '今日在岗', value: 0 },
        ],
      }
      this.attendanceStats = {
        title: '出勤数据',
        percent: 0,
        percentLabel: '出勤率',
        color: '#3478FF',
        list: [
          { label: '今日应出勤', value: 0 },
          { label: '今日实际出勤', value: 0 },
        ],
      }
      this.complaintData = {
        today: {
          total: 0,
          processing: 0,
          completed: 0,
        },
        month: {
          total: 0,
          processing: 0,
          completed: 0,
        },
      }
      this.complaintIsToday = true
      this.healthDataFromApi = []
      this.healthAlertList = []
      this.healthWristbandList = []
      this.healthWristbandTotal = 0
      this.spaceData = [
        { label: '信标数', value: 0 },
        { label: '空间数', value: 0 },
      ]
      this.stepRank = {
        updateTime: '',
        items: [],
      }
      this.messageList = []
      this.messagePageNum = 1
      this.messageTotal = 0
      this.updateSpaceChart()
      this.updateWristbandChart()
      this.updateAttendanceChart()
    },
  },
}
</script>

<style lang="less" scoped>
:deep(.ant-pro-page-header-wrap-page-header-warp) {
  display: none !important;
}

:deep(.ant-pro-page-header-wrap-children-content) {
  margin-top: 0 !important;
}

.dashboard-page {
  min-height: calc(100vh - 64px);
  padding: 16px 0px;
  // background: #f5f5f5;
  width: 100%;
  min-width: 0;
  overflow-x: hidden;
}
.panel-empty {
  margin-top: 70px;
}
.health-panel-pagination {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
/* 健康数据：表头固定、分页固定底部（与最新消息一致） */
.health-panel-body {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-right: 4px;
}
.health-panel-body .health-panel-table-wrap {
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}
.health-panel-body .health-panel-table-wrap .ant-table-wrapper {
  min-width: min-content;
}
/* 健康数据：仅隐藏表格内部纵向滚动条，横向使用浏览器默认样式 */
.health-panel-body .health-panel-table-wrap :deep(.ant-table-body::-webkit-scrollbar),
.health-panel-body .health-panel-table-wrap :deep(.ant-table-content::-webkit-scrollbar),
.health-panel-body .health-panel-table-wrap :deep(.ant-table-container::-webkit-scrollbar),
.health-panel-body .health-panel-table-wrap :deep(.ant-table-scroll::-webkit-scrollbar) {
  width: 0 !important;
}
.health-panel-body .health-panel-table-wrap :deep(.ant-table-placeholder .ant-empty-image),
.health-panel-body .health-panel-table-wrap :deep(.ant-table-placeholder .ant-empty-description) {
  display: none !important;
}
.health-panel-body .health-panel-pagination {
  flex-shrink: 0;
  margin-top: 10px;
}
.health-panel-body .panel-empty {
  flex: 1;
  min-height: 0;
}
.message-pagination {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
/* 最新消息：表头固定、分页固定底部 */
.message-panel-body {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-right: 4px;
}
.message-panel-body .message-panel-table-wrap {
  flex: 1;
  min-height: 0;
  min-width: 0; /* 允许 flex 子项收缩，使横向滚动生效 */
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}
/* 表格宽度按列宽总和计算，超出时由外层 wrap 显示横向滚动条 */
.message-panel-body .message-panel-table-wrap .ant-table-wrapper {
  min-width: min-content;
}
/* 最新消息：仅隐藏表格内部纵向滚动条，横向使用浏览器默认样式 */
.message-panel-body .message-panel-table-wrap :deep(.ant-table-body::-webkit-scrollbar),
.message-panel-body .message-panel-table-wrap :deep(.ant-table-content::-webkit-scrollbar),
.message-panel-body .message-panel-table-wrap :deep(.ant-table-container::-webkit-scrollbar),
.message-panel-body .message-panel-table-wrap :deep(.ant-table-scroll::-webkit-scrollbar) {
  width: 0 !important;
}
.message-panel-body .message-pagination {
  flex-shrink: 0;
  margin-top: 10px;
}
.message-panel-body .panel-empty {
  flex: 1;
  min-height: 0;
}
.filter-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px;
  margin-bottom: 16px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  border: none !important;
  box-shadow: none !important;
}
.filter-label {
  font-size: 16px;
  color: #1f2533;
  font-weight: 600;
}
.filter-label.time-label {
  margin-left: 8px;
}
.time-filter-picker {
  width: 260px;
}
/* 日期区间选择器：圆角 4px、高度 36px，与 select 一致（:deep 穿透组件） */
.time-filter-picker :deep(.ant-picker) {
  height: 36px !important;
  min-height: 36px !important;
  padding: 0 11px !important;
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
  display: flex !important;
  align-items: center !important;
}
.time-filter-picker :deep(.ant-picker-input) {
  height: 36px !important;
  padding: 0 !important;
}
.time-filter-picker :deep(.ant-picker-input input) {
  height: 36px !important;
  line-height: 36px !important;
  font-size: 14px !important;
}
.time-filter-picker :deep(.ant-picker-separator) {
  line-height: 36px !important;
}
.project-select {
  width: 232px;
  :deep(.ant-select-selector) {
    width: 232px !important;
    height: 36px !important;
    min-height: 36px !important;
    background: #FFFFFF !important;
    border-radius: 4px 4px 4px 4px !important;
    border: 1px solid #C7C7C7 !important;
    padding: 0 11px !important;
    display: flex !important;
    align-items: center !important;
  }
  :deep(.ant-select-selection-search) {
    height: 34px !important;
    line-height: 34px !important;
    display: flex !important;
    align-items: center !important;
  }
  :deep(.ant-select-selection-item) {
    line-height: 34px !important;
    height: 34px !important;
    display: flex !important;
    align-items: center !important;
  }
  :deep(.ant-select-selection-placeholder) {
    line-height: 34px !important;
    height: 34px !important;
    display: flex !important;
    align-items: center !important;
  }
  :deep(.ant-select-selection-search-input) {
    background: #FFFFFF !important;
    line-height: 34px !important;
    height: 34px !important;
    display: flex !important;
    align-items: center !important;
  }
  :deep(.ant-select-selection__rendered) {
    line-height: 34px !important;
    height: 34px !important;
    display: flex !important;
    align-items: center !important;
    margin-right: 30px !important;
  }
  :deep(.ant-select-selection__clear) {
    position: absolute !important;
    right: 11px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    width: 14px !important;
    height: 14px !important;
    line-height: 14px !important;
    font-size: 12px !important;
    color: rgba(0, 0, 0, 0.25) !important;
    z-index: 2 !important;
    cursor: pointer !important;
  }
  :deep(.ant-select-selection__clear:hover) {
    color: rgba(0, 0, 0, 0.45) !important;
  }
  :deep(.ant-select-arrow) {
    position: absolute !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    right: 11px !important;
    width: 12px !important;
    height: 12px !important;
    font-size: 12px !important;
    color: rgba(0, 0, 0, 0.25) !important;
    margin-top: 0 !important;
    transition: none !important;
  }
  :deep(.ant-select-selection__clear) {
    display: inline-block !important;
  }
  :deep(.ant-select-selection__clear) ~ .ant-select-arrow {
    display: none !important;
  }
  :deep(.ant-select-selection__clear) + .ant-select-arrow {
    display: none !important;
  }
  :deep(.ant-select-focused .ant-select-selector) {
    border-color: #C7C7C7 !important;
    box-shadow: none !important;
  }
  :deep(.ant-select:hover .ant-select-selector) {
    border-color: #C7C7C7 !important;
  }
}
.content-card {
  border-radius: 8px 8px 8px 8px;
  padding: 0;
  background: transparent;
}
.task-data-section {
  padding: 16px;
}
.task-data-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.section-title {
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 18px;
  color: #101010;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.summary-link {
  display: none;
}
.task-data-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.task-data-grid .task-data-card:nth-child(4),
.task-data-grid .task-data-card:nth-child(5) {
  grid-column: span 1;
}
.task-data-grid .task-data-card:nth-child(4) {
  grid-column: 1;
}
.task-data-grid .task-data-card:nth-child(5) {
  grid-column: 2;
}
@media (max-width: 1365px) and (min-width: 1200px) {
  .task-data-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .task-data-grid .task-data-card:nth-child(4) {
    grid-column: 1;
  }
  .task-data-grid .task-data-card:nth-child(5) {
    grid-column: 2;
  }
}
.task-data-card {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.task-data-icon {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
}
.task-data-content {
  flex: 1;
}
.task-data-label {
  margin: 0 0 8px 0;
  color: #1f2533;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
}
.task-data-value {
  margin: 0;
  color: #1f2533;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
}
.top-summary-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
  margin-top: 0;
}
@media (min-width: 1200px) {
  .top-summary-row {
    min-width: 0;
  }
  .top-card {
    min-width: 0;
    overflow: hidden;
  }
  /* 桌面端统一限制顶部三块卡片内文字换行，防止被挤压 */
  .stats-row-value,
  .stats-row-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .complaint-data-number,
  .complaint-data-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.top-card {
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  padding: 20px;
  border: none !important;
  box-shadow: none !important;
}

/* top-summary-row 中的卡片之间已经有 gap，不需要额外 margin-bottom */
.top-summary-row .top-card {
  margin-bottom: 0;
}
.stats-card.top-card {
  padding: 20px 20px 20px 20px;
}
/* 投诉数据卡片：2×2 网格铺满宽度，紧凑上下间距与格子高度 */
.complaint-data-section.top-card {
  padding: 10px 24px 12px;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
}
.complaint-data-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.complaint-data-title {
  font-size: 17px;
  font-weight: 600;
  color: #1a1a1a;
  letter-spacing: 0.02em;
}
.complaint-data-summary {
  display: flex;
  align-items: baseline;
  gap: 24px;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  color: #595959;
  font-weight: 400;
}
.complaint-data-summary-num {
  font-style: normal;
  color: #f5222d;
    font-weight: 600;
  margin-left: 4px;
}
.complaint-data-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 66px 66px;
  gap: 10px;
  width: 100%;
}
.complaint-data-grid--three {
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 66px;
}
.complaint-data-subcard {
  background: #f0f7ff;
  border: none;
  border-radius: 8px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px;
  transition: background 0.2s;
}
.complaint-data-subcard--clickable:hover {
  background: #e6f4ff;
}
.complaint-data-number {
  font-size: 22px;
  font-weight: 600;
  color: #262626;
  line-height: 1.2;
  margin-bottom: 2px;
}
.complaint-data-label {
  font-size: 13px;
  color: #8c8c8c;
  font-weight: 400;
  line-height: 1.2;
}
.complaint-data-subcard--clickable {
  cursor: pointer;
}
.complaint-data-divider {
  width: 1px;
  background: #e8e8e8;
  margin: 0 16px;
  align-self: stretch;
}
.stats-card {
  display: flex;
  flex-direction: column;
}
.stats-card__header,
.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  margin-bottom: 16px;
  margin-top: 0;
}
.stats-card__body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  min-height: 140px;
  margin-top: 0;
  padding-bottom: 0;
}
.stats-info {
  flex: 1;
  margin-bottom: 0;
  padding-bottom: 0;
}
.stats-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0;
  font-size: 14px;
  color: #1f2533;
  min-height: 50px;
}
.stats-info-columns {
  display: none;
}
.stats-info-column {
  display: none;
}
.stats-row-label {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #555555;
  margin-top: 4px;
  margin-bottom: 0;
  padding-bottom: 0;
  line-height: 1.5;
}
.stats-row-value {
  font-size: 24px;
  font-weight: 600;
  color: #1f2533;
  line-height: 1.2;
  margin: 0 0 4px 0;
}
.stats-chart {
  width: 140px;
  height: 140px;
  flex-shrink: 0;
  border: none;
}
.stats-chart-echart {
  width: 100%;
  height: 100%;
  border: none;
}
.bottom-grid {
  margin-bottom: 0;
  margin-top: 0;
}

/* 顶部模块已经有 margin-bottom，所以底部模块不需要 margin-top */
.bottom-grid .ant-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.bottom-grid .ant-row:last-child {
  margin-bottom: 0;
}

.panel-card {
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  padding: 20px;
  border: none !important;
  box-shadow: none !important;
  overflow: hidden;
  height: 380px;
}
.panel-fixed {
  display: flex;
  flex-direction: column;
  height: 380px;
  overflow: hidden;
}
@media (max-width: 1199px) {
  .panel-fixed {
    height: auto;
    min-height: 300px;
  }
}
.panel-fixed .panel-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}
.panel-body.scrollable {
  flex: 1;
  overflow-y: auto;
  padding-right: 4px;
  min-height: 0;
}
/* 表格面板不使用外层纵向滚动，避免与 scrollable 冲突出现多余竖向滚动条 */
.panel-body.scrollable.health-panel-body,
.panel-body.scrollable.message-panel-body {
  overflow: hidden;
}
.health-table {
  width: 100%;
  border-collapse: collapse;
  background: #ffffff;
}
/* 今日步数排行：仅隐藏纵向滚动条 */
.step-rank-panel-body::-webkit-scrollbar {
  width: 0 !important;
  display: none;
}
.step-rank-panel-body {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.health-table th {
  background: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
  line-height: 17px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  padding: 12px 16px;
}
.health-table th:first-child {
  text-align: left;
}
.health-table th:not(:first-child) {
  text-align: center;
}
.health-table td {
  border-bottom: 1px solid #f0f0f0;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  line-height: 17px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  padding: 12px 16px;
}
.health-table td:first-child {
  text-align: left;
  padding-right: calc(16px - 20px);
  box-sizing: border-box;
}
.health-table td:not(:first-child) {
  text-align: center;
}
.health-table thead {
  background: #ffffff;
}
.health-table-row--clickable {
  cursor: pointer;
}
.space-chart {
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  height: 260px;
  padding: 12px 0 0;
}
.space-chart-echart {
  width: 100%;
  height: 310px;
}
.space-bar {
  text-align: center;
}
.space-bar .value {
  font-weight: 600;
  color: #1f2430;
}
.space-bar .bar {
  width: 60px;
  border-radius: 20px 20px 0 0;
  margin: 8px auto;
  background: linear-gradient(180deg, #4c80ff, #2a5dff);
  box-shadow: none !important;
}
.space-bar .label {
  color: #8d96a7;
  font-size: 12px;
}
.rank-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.rank-list li {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f1f3f7;
}
@media (min-width: 1920px) {
  .top-summary-row {
    gap: 20px;
  }
  .stats-card__body {
    gap: 16px;
  }
  /* 大屏下任务卡片恢复为固定三列布局，并保证标题不换行 */
  .task-data-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .task-data-label {
    white-space: nowrap;
  }
  /* 大屏下避免手环/出勤/投诉卡片内容被挤压换行 */
  .stats-row-value,
  .stats-row-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .complaint-data-number,
  .complaint-data-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media (max-width: 1919px) and (min-width: 1680px) {
  .top-summary-row {
    gap: 16px;
  }
  .stats-card__body {
    gap: 16px;
  }
  .stats-chart {
    width: 130px;
    height: 130px;
  }
  .stats-row-value,
  .stats-row-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .complaint-data-number,
  .complaint-data-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media (max-width: 1679px) and (min-width: 1366px) {
  .top-summary-row {
    grid-template-columns: 2fr 1fr 1fr 1fr;
    gap: 14px;
  }
  .bottom-grid .ant-col {
    margin-bottom: 16px;
  }
  .stats-card__body {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }
  .stats-chart {
    width: 120px;
    height: 120px;
    flex-shrink: 0;
  }
  .stats-row-value {
    font-size: 22px;
  }
  .stats-row-label {
    font-size: 13px;
  }
  .task-data-grid {
    gap: 10px;
  }
  .task-data-card {
    padding: 14px;
  }
  .task-data-icon {
    width: 44px;
    height: 44px;
    font-size: 22px;
  }
  .task-data-value {
    font-size: 22px;
  }
  .panel-fixed {
    min-height: 320px;
  }
}
@media (max-width: 1365px) and (min-width: 1200px) {
  .filter-bar {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .project-select {
    width: 100%;
  }
  .time-label {
    margin-left: 0;
  }
  .time-filter-picker {
    width: 100%;
  }
  .top-summary-row {
    grid-template-columns: 2fr 1fr 1fr 1fr;
    gap: 12px;
  }
  .stats-card,
  .task-data-section {
    padding: 16px;
  }
  .complaint-data-section.top-card {
    padding: 11px 16px;
  }
  .stats-card__body {
    flex-direction: row;
    gap: 14px;
    min-height: 120px;
  }
  .stats-info {
    gap: 12px;
  }
  .stats-row {
    min-height: 45px;
  }
  .stats-row-value {
    font-size: 20px;
  }
  .stats-row-label {
    font-size: 12px;
  }
  .stats-chart {
    width: 110px;
    height: 110px;
    flex-shrink: 0;
  }
  .task-data-grid {
    gap: 8px;
  }
  .task-data-card {
    padding: 12px;
  }
  .task-data-icon {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
  .task-data-value {
    font-size: 20px;
  }
  .task-data-label {
    font-size: 13px;
  }
  .space-chart-echart {
    height: 260px;
  }
  .panel-body.scrollable {
    padding-right: 4px;
  }
  .panel-card {
    padding: 16px;
  }
  .panel-fixed {
    min-height: 300px;
  }
  .bottom-grid .ant-col {
    margin-bottom: 16px;
  }
  .panel-fixed {
    height: auto;
    min-height: 300px;
  }
}
@media (max-width: 1199px) and (min-width: 992px) {
  .dashboard-page {
    padding-bottom: 0;
  }
  .content-card {
    padding: 16px;
  }
  .top-summary-row {
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }
  .task-data-section {
    grid-column: span 2;
  }
  .stats-card__body {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    min-height: auto;
  }
  .stats-info {
    width: 100%;
    gap: 10px;
  }
  .stats-row {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    min-height: 40px;
  }
  .stats-row-value {
    font-size: 18px;
    margin: 0;
  }
  .stats-row-label {
    font-size: 12px;
    margin: 0;
  }
  .stats-chart {
    width: 100%;
    height: 120px;
    align-self: center;
  }
  .task-data-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }
  .task-data-card {
    padding: 12px;
  }
  .task-data-icon {
    width: 36px;
    height: 36px;
    font-size: 18px;
  }
  .task-data-value {
    font-size: 18px;
  }
  .task-data-label {
    font-size: 12px;
  }
  .panel-card {
    padding: 16px;
  }
  .panel-fixed {
    min-height: 280px;
  }
  .bottom-grid .ant-col {
    margin-bottom: 16px;
  }
  .panel-fixed {
    height: auto;
    min-height: 280px;
  }
}
@media (max-width: 991px) and (min-width: 768px) {
  .dashboard-page {
    padding: 16px;
  }
  .top-summary-row {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .stats-card__body {
    flex-direction: column;
    gap: 12px;
  }
  .stats-info {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  .stats-row {
    flex-direction: column;
    align-items: flex-start;
  }
  .stats-chart {
    width: 100%;
    height: 150px;
  }
  .task-data-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .task-data-grid .task-data-card:nth-child(4),
  .task-data-grid .task-data-card:nth-child(5) {
    grid-column: span 1;
  }
  .bottom-grid .ant-col {
    margin-bottom: 16px;
  }
  .panel-fixed {
    height: auto;
    min-height: 280px;
  }
}
@media (max-width: 767px) {
  .dashboard-page {
    padding: 12px;
  }
  .top-summary-row {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .stats-card,
  .task-data-section {
    padding: 12px;
  }
  .complaint-data-section.top-card {
    padding: 7px 12px;
  }
  .stats-card__body {
    flex-direction: column;
    gap: 12px;
  }
  .stats-info {
    width: 100%;
    gap: 10px;
  }
  .stats-row {
    min-height: 40px;
  }
  .stats-row-value {
    font-size: 18px;
  }
  .stats-row-label {
    font-size: 12px;
  }
  .stats-chart {
    width: 100%;
    height: 140px;
  }
  .task-data-grid {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  .task-data-card {
    padding: 12px;
  }
  .task-data-icon {
    width: 36px;
    height: 36px;
    font-size: 18px;
  }
  .task-data-value {
    font-size: 18px;
  }
  .task-data-label {
    font-size: 12px;
  }
  .panel-card {
    padding: 12px;
  }
  .panel-fixed {
    height: auto;
    min-height: 250px;
  }
  .bottom-grid .ant-col {
    margin-bottom: 16px;
  }
}
/* 顶部手环/出勤卡片：统计项按“左两条，右两条”两列展示（大屏） */
@media (min-width: 1200px) {
  .stats-card.top-card .stats-info {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 24px;
    row-gap: 12px;
  }
  /* 出勤数据区域保持垂直单列展示 */
  .stats-info--vertical {
    display: flex !important;
    flex-direction: column !important;
    row-gap: 16px;
  }
}
/* 步数排行名次：盾牌徽章造型（上圆角、下尖角） */
.rank-num {
  width: 28px;
  height: 32px;
  clip-path: polygon(0 6px, 6px 0, calc(100% - 6px) 0, 100% 6px, 100% 85%, 50% 100%, 0 85%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  color: #fff;
  margin-right: 12px;
  flex-shrink: 0;
  padding-top: 2px; /* 数字在盾牌内视觉居中 */
}
.rank-num.rk-1 {
  background: #e74c3c;
}
.rank-num.rk-2 {
  background: #ff9f43;
}
.rank-num.rk-3 {
  background: #ffc53d;
}
.rank-num.rk-4,
.rank-num.rk-5 {
  background: #95a5a6;
}
.rank-list img {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  margin-right: 12px;
}
.rank-info {
  flex: 1;
}
.rank-info .name {
  margin: 0;
  font-weight: 600;
  color: #1f2430;
}
.rank-info .desc {
  margin: 0;
  color: #8d96a7;
  font-size: 12px;
}
.rank-step {
  font-weight: 600;
  color: #1f2430;
}
.update-time {
  color: #8d96a7;
}

/* 任务详情弹窗 */
.task-detail-header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 5px;
  margin-bottom: 16px;
}
.task-detail-header-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.task-detail-status-row {
  margin-top: 0;
}
.task-detail-filter-label {
  font-size: 14px;
  color: #666;
  margin-right: 8px;
}
.task-detail-user-select {
  min-width: 220px;
  max-width: 320px;
}
.task-detail-status-select {
  border-radius: 4px;
}
.task-detail-status-select :deep(.ant-select-selector) {
  border-radius: 4px !important;
}
.task-detail-header-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.detail-header-single-line {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
}
.detail-header-single-line .filter-buttons {
  flex-shrink: 0;
  white-space: nowrap;
}
.detail-header-single-line .task-detail-header-right {
  margin-left: 12px;
  flex-wrap: nowrap;
  white-space: nowrap;
}
.task-detail-date-picker {
  min-width: 240px;
  border-radius: 4px;
}
.task-detail-date-picker :deep(.ant-picker),
.task-detail-date-picker :deep(.javaMain-picker) {
  border-radius: 4px !important;
}
.task-detail-footer-pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  padding: 16px 0 0;
}
/* 分页组件：页数、上下页按钮、每页条数选择器圆角 4px */
:deep(.ant-pagination-item),
:deep(.ant-pagination-prev .ant-pagination-item-link),
:deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 4px !important;
}
:deep(.ant-pagination-options .ant-select .ant-select-selector) {
  border-radius: 4px !important;
}
.custom-date-radio :deep(.ant-radio-button-wrapper) {
  border-radius: 4px !important;
}
.custom-date-radio :deep(.ant-radio-button-wrapper-checked) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}
.task-detail-custom-date-radio :deep(.ant-radio-button-wrapper-checked) {
  background-color: #ffffff !important;
  border-color: #d9d9d9 !important;
  color: #000000 !important;
}
.wristband-detail-custom-date-radio :deep(.ant-radio-button-wrapper-checked) {
  background-color: #ffffff !important;
  border-color: #d9d9d9 !important;
  color: #000000 !important;
}
.filter-buttons :deep(.ant-btn) {
  border-radius: 4px !important;
}
.filter-buttons :deep(.ant-btn-primary) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}
.attendance-detail-custom-btn {
  border-radius: 4px !important;
  background-color: #ffffff !important;
  border-color: #d9d9d9 !important;
  color: #000000 !important;
}
.complaint-detail-custom-btn {
  border-radius: 4px !important;
  background-color: #ffffff !important;
  border-color: #d9d9d9 !important;
  color: #000000 !important;
}
.attendance-detail-custom-btn:hover,
.attendance-detail-custom-btn:focus,
.complaint-detail-custom-btn:hover,
.complaint-detail-custom-btn:focus {
  background-color: #ffffff !important;
  border-color: #d9d9d9 !important;
  color: #000000 !important;
}

/* 任务数据卡片可点击 */
.task-data-card {
  cursor: pointer;
}

/* 手环数据每一项可点击，悬停为手型 */
.stats-row--clickable {
  cursor: pointer;
}

/* 大屏下投诉数据数字与文字避免被裁剪，允许正常显示 */
@media (min-width: 1200px) {
  .complaint-data-number,
  .complaint-data-label {
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: initial !important;
  }
}
</style>
<style lang="less">
/* 弹窗挂载在 body，全局生效：上内间距缩小 */
.ant-modal-body,
.ant-modal .ant-modal-body,
.javaMain-modal-wrap .ant-modal-body {
  padding-top: 14px !important;
}

/* 分页组件页数及每页条数选择器圆角 4px（页面内 + 弹窗内均生效） */
.ant-pagination-item,
.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link {
  border-radius: 4px !important;
}
.ant-pagination-options .ant-select .ant-select-selector {
  border-radius: 4px !important;
}
.ant-modal .ant-pagination-item,
.ant-modal .ant-pagination-prev .ant-pagination-item-link,
.ant-modal .ant-pagination-next .ant-pagination-item-link,
.javaMain-modal-wrap .ant-pagination-item,
.javaMain-modal-wrap .ant-pagination-prev .ant-pagination-item-link,
.javaMain-modal-wrap .ant-pagination-next .ant-pagination-item-link {
  border-radius: 4px !important;
}
.ant-modal .ant-pagination-options .ant-select .ant-select-selector,
.javaMain-modal-wrap .ant-pagination-options .ant-select .ant-select-selector {
  border-radius: 4px !important;
}

/* 数据概览筛选栏：日期区间选择器圆角 4px、高度 36px（与 select 一致），全局选择器确保覆盖组件库样式 */
.filter-bar .time-filter-picker.ant-picker,
.filter-bar .time-filter-picker .ant-picker {
  height: 36px !important;
  min-height: 36px !important;
  padding: 0 11px !important;
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
  display: flex !important;
  align-items: center !important;
}
.filter-bar .time-filter-picker .ant-picker-input {
  height: 36px !important;
  padding: 0 !important;
}
.filter-bar .time-filter-picker .ant-picker-input input {
  height: 36px !important;
  line-height: 36px !important;
  font-size: 14px !important;
}
.filter-bar .time-filter-picker .ant-picker-separator {
  line-height: 36px !important;
}
</style>

<style lang="less">
/* 底部面板：隐藏纵向滚动条，横向保留浏览器默认样式 */
.dashboard-page .health-panel-table-wrap .ant-table-body::-webkit-scrollbar,
.dashboard-page .health-panel-table-wrap .ant-table-content::-webkit-scrollbar,
.dashboard-page .health-panel-table-wrap .ant-table-container::-webkit-scrollbar,
.dashboard-page .health-panel-table-wrap .ant-table-scroll::-webkit-scrollbar,
.dashboard-page .message-panel-table-wrap .ant-table-body::-webkit-scrollbar,
.dashboard-page .message-panel-table-wrap .ant-table-content::-webkit-scrollbar,
.dashboard-page .message-panel-table-wrap .ant-table-container::-webkit-scrollbar,
.dashboard-page .message-panel-table-wrap .ant-table-scroll::-webkit-scrollbar {
  width: 0 !important;
}
.dashboard-page .step-rank-panel-body::-webkit-scrollbar {
  width: 0 !important;
  display: none;
}
.dashboard-page .step-rank-panel-body {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
</style>
